import Vue from "vue"
import { v1 } from "uuid"
import { CATEGORY_MODE } from "@/consts/index.js"
const uuid = { v1 }
import {
  getAttrById,
  getTreeAttrById,
  findPathByLeafId,
  deepChangeUid,
  findCurrentComponentPathInLayoutByRectId,
  checkIrregularLayout,
  findDeleteLayout,
  deleteLayout,
  handleFindLayoutComponentColsParentRowByUid,
  findHistoryLayoutType,
  findLastLeafLayout,
  deleteGroupLayout,
  getAllRectInNewLayout,
  changeOption,
  isExist,
  findRectPath,
  simpleDeepClone,
  smartMathMax
} from "utils"
import states from "../states/state"
import { event } from "utils/event"
import { home } from "dependencies/emptyLayout/diffrence_options"
import { LayoutGenerator } from "dependencies/emptyLayout/utils/layoutGenerator"
import {
  colAnimateSync,
  swiperColAnimateSync,
  copyAnimateRelation,
  delAnimateInRect
} from "../../../utils/event/animate"
import { handleChildAppid } from "../../../utils/reCreatAppid"
//遍历自由布局组件里面的元素
function findLayoutRect(org, cb) {
  if (org && typeof org === "object") {
    for (let k in org) {
      if (typeof org[k] === "object") {
        if (k === "elementOptions") {
          let objArr = Array.isArray(org[k]) ? org[k] : [org[k]]
          objArr.forEach(option => {
            cb(option, org.uid)
          })
        }
        if (k === "componentBoxOptions") {
          cb(org, org.uid, "componentBoxOptions")
        }
        findLayoutRect(org[k], cb)
      }
    }
  }
}
//布局组件内部组件可配置项修改事件处理函数
function handleFindLayoutComponentOptions(options, uid, cb) {
  let _rows = options
  let _outStatus = false
  if (_rows) {
    _rows.forEach(rowsItem => {
      if (rowsItem && rowsItem.cols && !_outStatus) {
        let itemCols = rowsItem.cols
        itemCols.forEach(colsItem => {
          if (colsItem.uid === uid) {
            _outStatus = true
            cb(colsItem)
            return
          }
          if (colsItem.uid !== uid && colsItem.rows !== null) {
            handleFindLayoutComponentOptions(colsItem.rows, uid, cb)
          }
        })
      } else return
    })
  }
}
//遍历所有单元格，执行回调
function excuteCellLayoutCallback(options, cb) {
  let _rows = options
  if (_rows) {
    _rows.forEach(rowsItem => {
      if (rowsItem && rowsItem.cols) {
        let itemCols = rowsItem.cols
        itemCols.forEach(colsItem => {
          if (colsItem.rows) {
            excuteCellLayoutCallback(colsItem.rows, cb)
          } else {
            cb(colsItem)
          }
        })
      }
    })
  }
}
//画布布局内layoutoption修改事件处理函数
function handleFindLayoutStageOptionsByUid(options, uid, cb) {
  for (let i = 0; i < options.length; i++) {
    const item = options[i]
    if (item.uid === uid) {
      cb(item)
      return
    } else {
      let tempOptions = item.cols || item.rows
      if (tempOptions) {
        handleFindLayoutStageOptionsByUid(tempOptions, uid, cb)
      }
    }
  }
}

//通过画布uid找到该节点
function handleFindLayoutByUid(options, uid) {
  const opts = Array.isArray(options) ? options : [options]
  let parent = null
  let target = null
  let index = 0
  function travel(data, par) {
    for (let i = 0; i < data.length; i++) {
      const item = data[i]
      if (item.uid === uid) {
        parent = par
        target = item
        index = i
        return
      }
      const temp = item.rows || item.cols
      if (temp) {
        travel(temp, item)
      }
    }
  }
  travel(opts, options)
  return [target, parent, index]
}

//布局组件内部组件cols查找上一级cols函数
function handleFindLayoutComponentOptionsCols(options, uid, cb) {
  let _rows = options
  let _outStatus = false
  if (_rows) {
    for (let i = 0; i < _rows.length; i++) {
      const rowsItem = _rows[i]
      if (rowsItem && rowsItem.cols && !_outStatus) {
        let itemCols = rowsItem.cols
        for (let j = 0; j < itemCols.length; j++) {
          const colsItem = itemCols[j]
          if (colsItem.uid === uid) {
            _outStatus = true
            cb(itemCols, j, _rows, i)
            return
          }
          if (colsItem.uid !== uid && colsItem.rows !== null) {
            handleFindLayoutComponentOptionsCols(colsItem.rows, uid, cb)
          }
        }
      } else return
    }
  }
}
function getAttribute(state, ids) {
  Object.keys(ids).forEach(k => {
    if (ids[k] === null) delete ids[k]
  })
  let rect = getAttrById(state, ids, "rect").options
  if (ids.hasOwnProperty("elementInAutoLayoutId") && ids.elementInAutoLayoutId !== undefined) {
    rect = getAttrById(state, ids, "elementInAutoLayout")
  }
  //找轮播组件的具体到某一页的数据
  if (ids.hasOwnProperty("swiperContent_id") && !ids.hasOwnProperty("elementInSwiperId")) {
    return rect.content.find(i => i.swiperContent_id === ids.swiperContent_id)
  }
  //找轮播组件的具体到某一页内的组件的数据
  if (ids.hasOwnProperty("swiperContent_id") && ids.hasOwnProperty("elementInSwiperId")) {
    return rect.content
      .find(i => i.swiperContent_id === ids.swiperContent_id)
      .elementOptions.find(i => i.elementInSwiperId === ids.elementInSwiperId)
  }
  return getAttrById(state, ids, "rect")
}

/**
 * 更新左侧树第二级的结构
 * @param state
 * @param data
 */
function updateTreeSecondData(state, data) {
  let treeData = { ...state.treeData }
  let temp = []
  for (let i = 0; i < data.length; i++) {
    temp.push({ id: data[i].container_id, label: "画布" + data[i].container_id, children: [] })
    let result = treeData[0].children.filter(item => item.id == data[i].container_id)
    if (result.length > 0 && result[0].children.length > 0) {
      result[0].children.forEach((item, index) => {
        temp[i].children.push(item)
      })
    }
  }
  state.treeData[0].children = []
  state.treeData[0].children = [...temp]
}

/**
 * 找出布局组件层级
 * @param options
 * @param rowData
 * @returns {*}
 */
function handleFindLayoutComponentsLevel(options, rowData) {
  let _cols = options
  if (_cols) {
    for (let i = 0; i < _cols.length; i++) {
      rowData.children.push({ label: "col", id: i, uid: _cols[i].uid, children: [] })
      if (!_cols[i].rows) {
        let itemElementOptions = _cols[i].elementOptions
        for (let g = 0; g < itemElementOptions.length; g++) {
          rowData.children[i].children.push({ label: itemElementOptions[g].innerElement, id: g })
        }
      } else {
        let itemRows = _cols[i].rows
        for (let k = 0; k < itemRows.length; k++) {
          rowData.children[i].children.push({ label: "row", id: k, children: [] })
          if (itemRows[k].cols) {
            handleFindLayoutComponentsLevel(itemRows[k].cols, rowData.children[i].children[k])
          }
        }
      }
    }
  }
  return rowData
}

/**
 * 找出布局组件中标题等其他组件的层级
 * @param options
 * @param titleData
 * @returns {*}
 */
function handleFindLayoutTitlesLevel(options, titleData) {
  if (options) {
    for (let i = 0; i < options.length; i++) {
      titleData.children.push({ label: options[i].type, id: i, children: [] })
      let elements = options[i].elementOptions
      if (elements.length > 0) {
        for (let j = 0; j < elements.length; j++) {
          titleData.children[i].children.push({ label: elements[j].innerElement, id: j })
        }
      }
    }
  }
  return titleData
}
function initUid(data) {
  if (data.cols && data.cols.length) {
    data.cols.forEach(_col => {
      _col.uid = uuid.v1()
      if (_col.rows && _col.rows.length) {
        _col.rows.forEach(_row => {
          initUid(_row)
        })
      }
    })
  }
}

// 为了保证被元素不超出范围，限制宽高在被单元格内
function sureElementsInCell(uid, data) {
  const componentBox = document.getElementById(`componentBox_after${uid}`)
  // 如果容器还未生成，不需要执行
  if (!componentBox) return
  const width = componentBox.offsetWidth
  const height = componentBox.offsetHeight
  data.elementOptions.forEach(el => {
    const { paddingTop, paddingBottom, paddingLeft, paddingRight } = data.componentBoxOptions
    // 最大高度为：单元格高度 - 上下内间距
    // const maxHeight = height - paddingTop - paddingBottom
    const maxHeight = height
    // 最大宽度为：单元格宽度 - 左右内间距
    // const maxWidth = width - paddingLeft - paddingRight
    const maxWidth = width
    if (el.topType === "%") {
      // 百分比高度不会溢出，非百分比需要取当前和容器高度较小值
      if (el.heightType !== "%") {
        el.height = Math.min(maxHeight, el.height)
      }
    } else {
      // top值超出单元格高度时，需要将它重置
      if (el.top >= maxHeight) {
        // 给定位元素高度留的位置
        const rest = el.heightType === "%" ? parseInt(height * (el.height / 100)) : el.height
        el.top = height > rest ? height - rest : 0
      }
      // 非百分比需要取当前和（容器高度 - top）较小值
      if (el.heightType !== "%") {
        el.height = Math.min(maxHeight - el.top, el.height)
      }
    }
    if (el.leftType === "%") {
      // 百分比宽度不会溢出，非百分比需要取当前和容器宽度较小值
      if (el.widthType !== "%") {
        el.width = Math.min(maxWidth, el.width)
      }
    } else {
      // left值超出单元格高度时，需要将它重置
      if (el.left >= maxWidth) {
        // 给定位元素宽度留的位置
        const rest = el.widthType === "%" ? parseInt(width * (el.width / 100)) : el.width
        el.left = width > rest ? width - rest : 0
      }
      // 非百分比需要取当前和（容器宽度 - left）较小值
      if (el.widthType !== "%") {
        el.width = Math.min(maxWidth - el.left, el.width)
      }
    }
  })
}

export default function publicMutations(allTypes) {
  return {
    [allTypes.CHANGE_LAYOUT_SIZE](state, data) {
      let tempRect = getAttrById(state, data, "rect").options
      if (!data.row_id) {
        handleFindLayoutComponentOptions(tempRect.rows, data.uid, colsItem => {
          Vue.set(colsItem, "componentBoxOptions", data.option_val)
        })
      } else {
        handleFindLayoutComponentOptions(tempRect.rows, data.uid, colsItem => {
          Vue.set(colsItem, data.rows[data.row_id][data.option_name], data.option_val)
        })
      }
    },
    [allTypes.UPDATE_RECT_MODULE_ID_TYPE_ID](state, data) {
      const rect = getAttrById(state, data)
      const rectOptions = rect.options ? rect.options : rect
      // if (
      //   (!data.hasOwnProperty("elementInLayoutId") || data.elementInLayoutId === null) &&
      //   (!data.hasOwnProperty("elementInSwiperId") || data.elementInSwiperId === null) || 
      //   (isExist(data.directionIndex) && isExist(data.elementInLayoutId))
      // ) {
      //   Vue.set(rect.options, "moduleId", data.moduleId)
      //   Vue.set(rect.options, "typeId", data.typeId)
      // }
      if (isExist(data.elementInLayoutId) && rectOptions.rows){
        // 看逻辑应该只有自由布局才走这里 其他都应该走else 解决收藏自由布局中的元素会报错阻断
        const row_id = rectOptions.categoryMode === CATEGORY_MODE.SAME ? 0 : rectOptions.activeIndex
        const tempRect = [rectOptions.rows[row_id]]
        handleFindLayoutComponentOptions(tempRect, data.uid, colsItem => {
          Vue.set(
            colsItem.elementOptions.find(it => it.elementInLayoutId === data.elementInLayoutId),
            "moduleId",
            data.moduleId
          )
          Vue.set(
            colsItem.elementOptions.find(it => it.elementInLayoutId === data.elementInLayoutId),
            "typeId",
            data.typeId
          )
        })
        Vue.set(getAttrById(state, data, "rect").options.rows, row_id, tempRect[0])
      } else if (rectOptions) {
        Vue.set(rectOptions, "moduleId", data.moduleId)
        Vue.set(rectOptions, "typeId", data.typeId)
      }
    },
    [allTypes.CHANGE_VDR_OPTIONS](state, data) {
      let tempRect = getAttrById(state, data, "rect")
      Vue.set(tempRect, data.option_name, data.option_val)
    },
    [allTypes.CHANG_BIG_SCREEN_OPTION](state, data) {
      const rectOptions = getAttrById(state, data, "rect").options
      if (data.uid && data.uid !== null) {
        //在布局组件中的图表组件的编辑的情况
        const row_id = rectOptions.categoryMode === CATEGORY_MODE.SAME ? 0 : rectOptions.activeIndex
        let tempRect = [rectOptions.rows[row_id]]
        handleFindLayoutComponentOptions(tempRect, data.uid, colsItem => {
          changeChartOption(colsItem.elementOptions.find(it => it.elementInLayoutId === data.elementInLayoutId))
        })
      } else {
        //在画布中的情况
        let tempRect = rectOptions
        changeChartOption(tempRect)
      }
      function changeChartOption(tempRect) {
        let tempObj = {}
        let nameMap = data.option_name.split(".")
        let lastName = nameMap[nameMap.length - 1]
        nameMap.pop()
        nameMap.forEach((item, index) => {
          if (!index) {
            tempObj = tempRect[item]
          } else {
            tempObj = tempObj[item]
          }
        })
        Vue.set(tempObj, lastName, data.option_val)
      }
    },
    [allTypes.UPDATE_COLS_OPTION](state, data) {
      let tempRect = getAttrById(state, data, "rect").options
      if (data.elementInAutoLayoutId !== undefined) {
        tempRect = getAttrById(state, data, "elementInAutoLayout")
      }
      handleFindLayoutComponentOptions(tempRect.rows, data.uid, colsItem => {
        if (Array.isArray(data.option_name)) {
          data.option_name.forEach((item, index) => {
            Vue.set(colsItem, item, data.option_val[index])
          })
        } else if (data.option_name.includes("componentBoxOptions")) {
          const realOptName = data.option_name.split("-")[1]
          changeOption(colsItem.componentBoxOptions, { option_name: realOptName, option_val: data.option_val })
        } else {
          Vue.set(colsItem, data.option_name, data.option_val)
        }
      })
    },

    [allTypes.UPDATE_CREATE_BLOCK_TIMES](state, data) {
      Vue.set(getAttrById(state, data, "rect").options, "createBlockTimes", data.createBlockTimes)
    },

    [allTypes.ADD_COMPONENT_IN_LAYOUT](state, data) {
      if (data?.elementOptions?.innerElement === "emptyLayoutComponent") return
      let optionNow = getAttrById(state, data, "rect").options
      if (data.elementInAutoLayoutId !== undefined) {
        optionNow = getAttrById(state, data, "elementInAutoLayout")
      }
      const useActiveIndex = optionNow?.categoryMode === CATEGORY_MODE.SAME ? 0 : optionNow.activeIndex
      let row_id = useActiveIndex
      if (row_id > optionNow.rows.length - 1) {
        row_id = 0
        Vue.set(optionNow, "activeIndex", row_id)
      }
      let tempRect = [JSON.parse(JSON.stringify(optionNow.rows[row_id]))]
      function updateId(data) {
        // 拷贝自动布局到单元格时，需要修改自动布局下组件的elementInLayoutId
        data.elementOptions?.forEach(item => {
          item.elementInLayoutId = data.elementInLayoutId
          if (item.innerElement === "cxAutoLayout" && item.elementOptions?.length > 0) {
            updatePath(item)
          }
        })
      }
      handleFindLayoutComponentOptions(tempRect, data.uid, colsItem => {
        let elementInLayoutId
        if (!colsItem.elementOptions || colsItem.elementOptions.length === 0) {
          colsItem.elementOptions = []
          elementInLayoutId = 0
        } else {
          elementInLayoutId = 0
          colsItem.elementOptions.forEach(item => {
            elementInLayoutId = item.elementInLayoutId > elementInLayoutId ? item.elementInLayoutId : elementInLayoutId
          })
          elementInLayoutId = elementInLayoutId + 1
        }
        data.elementOptions.elementInLayoutId = elementInLayoutId
        if (data.elementOptions?.innerElement === "cxAutoLayout") {
          updateId(data.elementOptions)
        }
        if (data.hasOwnProperty("insertIndex")) {
          colsItem.elementOptions.splice(data.insertIndex, 0, data.elementOptions)
        } else {
          colsItem.elementOptions.push(data.elementOptions)
        }
      })
      Vue.set(optionNow.rows, row_id, tempRect[0])
      // 更新图层标志
      Vue.set(states, "isUpdateLayerDataFlag", true)
    },

    [allTypes.ADD_COMPONENT_IN_LAYOUT_AROUND](state, data) {
      let rect = getAttrById(state, data, "rect").options
      if (data.elementInAutoLayoutId !== undefined) {
        rect = getAttrById(state, data, "elementInAutoLayout")
      }
      const temp = JSON.parse(JSON.stringify(rect.titleOptions[data.direction].elementOptions)).sort(
        (a, b) => a.elementInLayoutId - b.elementInLayoutId
      )
      const newOptions = {
        innerElement: data.elementOptions.innerElement,
        isActive: false,
        isShow: true,
        elementInLayoutId: temp.length > 0 ? temp[temp.length - 1].elementInLayoutId + 1 : 0,
        options: data.elementOptions
      }
      temp.push(newOptions)
      Vue.set(rect.titleOptions[data.direction], "elementOptions", temp)
      // 更新图层标志
      Vue.set(states, "isUpdateLayerDataFlag", true)
    },

    // -------------------------------------
    /*修改布局组件内的组件的数据，可以有批量修改和单个修改两种方式
        批量修改方式：data = {
            container_id:......,
            rect_id:......                         ！！！option_name和elementInLayoutId和option_val三个数组的顺序必须一一对应
            option_name: [change1,change2],        !!!!!批量修改是指批量修改单个elementOptions的多个属性值，并不是批量修改多个elementOptions的多个值
            elementInLayoutId: [elementInLayoutId,elementInLayoutId],
            uid: uid,
            option_val: [val1,val2]
        }
        单个修改方式：data = {
            container_id:......,
            rect_id:......
            option_name: name,                 ！！！option_name和elementInLayoutId和option_val三个直接传值
            elementInLayoutId: id,
            uid: uid,
            option_val: val
        }

        */
    [allTypes.CHANGE_LAYOUT_OPTION](state, data) {
      let rect = getAttrById(state, data, "rect").options
      let index = -1
      let ids = {
        container_id: data.container_id,
        rect_id: data.rect_id,
        elementInAutoLayoutId: data.elementInAutoLayoutId,
        path: data.path
      }
      if (data.elementInAutoLayoutId !== undefined && rect.innerElement === "cxAutoLayout") {
        // 自由布局在自动布局中
        rect = getAttrById(state, ids, "elementInAutoLayout")
        index = getAttrById(state, ids, "autoLayout")?.elementOptions?.findIndex(
          it => it.elementInAutoLayoutId === data.elementInAutoLayoutId
        )
      }
      let rows = []
      if (data.isCheckAllCol) {
        // 不同tab标签，修改子组件的appid,此时不在activeIndex下
        rows = rect.rows
      } else {
        const useActiveIndex = rect.categoryMode === CATEGORY_MODE.SAME ? 0 : rect.activeIndex
        rows = [rect.rows[useActiveIndex]]
      }
      rows.forEach(tempRect => {
        handleFindLayoutComponentOptions([tempRect], data.uid, colsItem => {
          if (Array.isArray(data.option_name) && Array.isArray(data.option_val)) {
            data.option_name.forEach((item, index) => {
              Vue.set(
                colsItem.elementOptions.find(it => it.elementInLayoutId === data.elementInLayoutId),
                data.option_name[index],
                data.option_val[index]
              )
            })
          } else {
            let node = colsItem.elementOptions.find(it => it.elementInLayoutId === data.elementInLayoutId)
            if (data.elementInAutoLayoutId !== undefined && node && node.elementOptions && Array.isArray(node.elementOptions)) {
              node = node.elementOptions.find(it => it.elementInAutoLayoutId === data.elementInAutoLayoutId)
            }
            changeOption(node, data)
          }
        })
      })
      // if (index !== -1) {
      //   // 更新自动布局数据
      //   let elementOptions = getAttrById(state, ids, "elementInAutoLayout")?.elementOptions
      //   elementOptions.splice(index, 1, rect)
      //   Vue.set(getAttrById(state, ids, "elementInAutoLayout"), "elementOptions", elementOptions)
      // }
    },
    [allTypes.CHANGE_LAYOUT_COMPONENTBOX_OPTION](state, data) {
      let rect = getAttrById(state, data, "rect").options
      if (data.elementInAutoLayoutId !== undefined) {
        rect = getAttrById(state, data, "elementInAutoLayout")
      }
      const useActiveIndex = rect?.categoryMode === CATEGORY_MODE.SAME ? 0 : rect.activeIndex
      const row_id = useActiveIndex
      let tempRect = [rect.rows[row_id]]
      handleFindLayoutComponentOptions(tempRect, data.uid, colsItem => {
        sureElementsInCell(data.uid, data.content)
        // 处理单元格同步之后 动画对应uid的修改
        colAnimateSync(data)

        Vue.set(colsItem, "elementOptions", data.content.elementOptions)
        Vue.set(colsItem, "componentBoxOptions", data.content.componentBoxOptions)
        Vue.set(colsItem, "detailsPageTarget", data.content.detailsPageTarget)
      })
    },
    [allTypes.CHANGE_LAYOUT_CELL_BOX_OPTION_SIZE](state, data) {
      let rect = getAttrById(state, data, "rect").options
      if (data.elementInAutoLayoutId !== undefined) {
        rect = getAttrById(state, data, "elementInAutoLayout")
      }
      const useActiveIndex = rect?.categoryMode === CATEGORY_MODE.SAME ? 0 : rect.activeIndex
      const row_id = useActiveIndex
      const options = [rect.rows[row_id]]
      excuteCellLayoutCallback(options, colsItem => {
        sureElementsInCell(colsItem.uid, colsItem)
      })
    },
    [allTypes.CHANGE_ROW_COL_SIZE](state, data) {
      if (data.type === "width") {
        Vue.set(data.col, "width", data.val)
      } else if (data.type === "openIndex") {
        Vue.set(data.row, "openIndex", data.val)
      } else if (data.type === "colHeight") {
        Vue.set(data.col, "height", data.val)
      } else {
        Vue.set(data.row, "height", data.val)
      }
    },
    [allTypes.CHANGE_ROW_COL_UID](state, data) {
      const rectAttr = getAttrById(state, data, "rect")
      if (data.elementInAutoLayoutId !== undefined) {
        rectAttr = getAttrById(state, data, "elementInAutoLayout")
      }
      let rows = rectAttr.options.rows
      let isFirstLevel = true
      handleFindLayoutStageOptionsByUid(rows, data.uid, opt => {
        isFirstLevel = false
        let firstColUid = opt.rows[0].cols[0].uid
        let wrapUid = opt.uid
        Vue.set(opt, "uid", firstColUid)
        Vue.set(opt.rows[0].cols[0], "uid", wrapUid)
        // 将原有的单元格动画替换过去
        let clickAnimates = opt.componentBoxOptions.clickAnimates
        let hoverAnimates = opt.componentBoxOptions.hoverAnimates
        Vue.set(opt.rows[0].cols[0].componentBoxOptions, "clickAnimates", clickAnimates)
        Vue.set(opt.rows[0].cols[0].componentBoxOptions, "hoverAnimates", hoverAnimates)
        Vue.set(opt.componentBoxOptions, "clickAnimates", [])
        Vue.set(opt.componentBoxOptions, "hoverAnimates", [])
      })
      if (isFirstLevel) {
        const useActiveIndex = rectAttr.options.categoryMode === CATEGORY_MODE.SAME ? 0 : rectAttr.options.activeIndex
        Vue.set(rows[useActiveIndex].cols[0], "uid", data.uid)
      }
    },
    [allTypes.DEL_LAYOUT_ELEMENT](state, data) {
      if (
        Object.values(data).some(item => {
          return item === null
        })
      ) {
        throw new Error("Some data is null, its incomplete,found in state/stage/mutations/DEL_LAYOUT_ELEMENT")
      }
      let rectAttr = getAttrById(state, data, "rect").options
      //删除布局组件内的组件同时 需要删除该组件的事件（如果有事件的话）
      let elementAttr = undefined
      if (data.elementInAutoLayoutId !== undefined) {
        rectAttr = getAttrById(
          state,
          {
            container_id: data.container_id,
            rect_id: data.rect_id,
            elementInAutoLayoutId: data.elementInAutoLayoutId,
            path: data.path
          },
          "elementInAutoLayout"
        )
        elementAttr = getAttrById(state, data, "autoLayout")
      } else {
        elementAttr = getAttrById(state, data, "elementInLayout")
      }
      event.deleteEventByDep(data, elementAttr?.innerElement)
      //开始处理组件删除逻辑
      const useActiveIndex = rectAttr?.categoryMode === CATEGORY_MODE.SAME ? 0 : rectAttr.activeIndex
      const row_id = useActiveIndex
      let tempRect = [JSON.parse(JSON.stringify(rectAttr.rows[row_id]))]

      handleFindLayoutComponentOptions(tempRect, data.uid, colsItem => {
        if (Array.isArray(data.elementInLayoutId)) {
          //批量删除
          data.elementInLayoutId.forEach((item, index) => {})
        } else {
          // 单个删除
          const start = colsItem.elementOptions.findIndex(it => it.elementInLayoutId === data.elementInLayoutId)
          // 删除对应的动画
          delAnimateInRect(state, data, colsItem.elementOptions[start])
          colsItem.elementOptions.splice(start, 1)
          // 从elementOptions重新遍历，是为了保证删除历史数据
          if (colsItem.detailsPageTarget) {
            const restIds = colsItem.elementOptions.map(ele => ele.elementInLayoutId)
            colsItem.detailsPageTarget = colsItem.detailsPageTarget.filter(target => restIds.includes(target))
          }
        }
      })
      // 遍历删除当前组件里的动画
      findLayoutRect(rectAttr.rows[row_id], (rect, uid, type) => {
        handleFindLayoutComponentOptions(tempRect, uid, colsItem => {
          if (type === "componentBoxOptions") {
            colsItem.componentBoxOptions = rect.componentBoxOptions
          } else {
            colsItem.elementOptions?.forEach((item, index) => {
              if (item.elementInLayoutId === rect.elementInLayoutId) {
                colsItem.elementOptions[index] = rect
              }
            })
          }
        })
      })
      console.log("tempRect[0]", tempRect[0])
      Vue.set(rectAttr.rows, row_id, tempRect[0])
      // 更新图层标志
      Vue.set(states, "isUpdateLayerDataFlag", true)
    },
    [allTypes.DEL_LAYOUT_AROUND_ELEMENT](state, data) {
      let rectAttr = getAttrById(state, data, "rect").options
      if (data.elementInAutoLayoutId !== undefined) {
        rectAttr = getAttrById(state, data, "elementInAutoLayout")
      }
      //删除布局组件内的组件同时 需要删除该组件的事件（如果有事件的话）
      event.deleteEventByDep(data)
      let temp = JSON.parse(JSON.stringify(rectAttr.titleOptions[data.directionIndex].elementOptions))
      let _index = temp.findIndex(it => it.elementInLayoutId === data.elementInLayoutId)
      // 删除组件的同时，需要删除组件对应的动画
      delAnimateInRect(state, data, temp[_index])
      temp.splice(_index, 1)
      Vue.set(rectAttr.titleOptions[data.directionIndex], "elementOptions", temp)
      // 更新图层标志
      Vue.set(states, "isUpdateLayerDataFlag", true)
    },
    [allTypes.ADD_LAYOUT_BLOCK](state, data) {
      let rectAttr = getAttrById(state, data, "rect").options
      if (data.elementInAutoLayoutId !== undefined) {
        rectAttr = getAttrById(state, data, "elementInAutoLayout")
      }
      const useActiveIndex = rect?.categoryMode === CATEGORY_MODE.SAME ? 0 : rect.activeIndex
      const row_id = useActiveIndex
      let tempRect = [JSON.parse(JSON.stringify(rectAttr.rows[row_id]))]
      if (data.type === "addCols") {
        // 找到包含当前选中的col对象的哪个colsshuzu
        handleFindLayoutComponentOptionsCols(tempRect, data.uid, (colsArr, tarColsIndex) => {
          colsArr.push(data.cols)
        })
      } else if (data.type === "addRows") {
        handleFindLayoutComponentOptions(tempRect, data.uid, colsItem => {
          if (colsItem.rows) {
            colsItem.rows.push(data.appendData)
          } else {
            colsItem.rows = []
            colsItem.rows.push(data.appendData)
          }
        })
      } else {
        throw new Error("data.type is not allowed")
      }
      Vue.set(rectAttr.rows, row_id, tempRect[0])
      // 更新图层标志
      Vue.set(states, "isUpdateLayerDataFlag", true)
    },
    [allTypes.RESET_LAYOUT_BLOCK](state, data) {
      let rectAttr = getAttrById(state, data, "rect").options
      if (data.elementInAutoLayoutId !== undefined) {
        rectAttr = getAttrById(state, data, "elementInAutoLayout")
      }
      const useActiveIndex = rect?.categoryMode === CATEGORY_MODE.SAME ? 0 : rect.activeIndex
      const row_id = useActiveIndex
      const options = rectAttr.rows[row_id]
      if (data.editType === "cell") {
        let attr = options.cols[0]
        let editAttr = attr
        let editParent = null
        if (data.editType === "cell") {
          ;[editAttr, editParent] = handleFindLayoutByUid(attr, data.uid)
        }
        delete editAttr.rows
        sessionStorage.setItem("willActiveUid", editAttr.uid)
      } else {
        const temp = JSON.parse(JSON.stringify(options.cols[0]))
        const cell = firstCell(temp)
        delete temp.rows
        temp.componentBoxOptions = cell.componentBoxOptions
        temp.elementOptions = cell.elementOptions
        Vue.set(options.cols, 0, temp)
      }
      // 第一个底层列单元格
      function firstCell(cell) {
        if (cell.rows && cell.rows.length) {
          return firstCell(cell.rows[0])
        }
        if (cell.cols && cell.cols.length) {
          return firstCell(cell.cols[0])
        }
        return cell
      }
      // 更新图层标志
      Vue.set(states, "isUpdateLayerDataFlag", true)
    },
    [allTypes.DEL_LAYOUT_COL](state, data) {
      let rect = getAttrById(state, data, "rect").options
      if (data.elementInAutoLayoutId !== undefined) {
        rect = getAttrById(state, data, "elementInAutoLayout")
      }
      const useActiveIndex = rect?.categoryMode === CATEGORY_MODE.SAME ? 0 : rect.activeIndex
      const row_id = useActiveIndex
      const attr = rect.rows[row_id].cols[0]
      let layout
      // 编组后的列删除
      if (attr.disableSetColAndRow) {
        layout = deleteGroupLayout(rect.rows[row_id], [data.uid])
        Vue.set(rect.rows, 0, layout)
      } else {
        layout = deleteLayout(attr, [data.uid])
        Vue.set(rect.rows[row_id].cols, 0, layout)
      }
      // 更新图层标志
      Vue.set(states, "isUpdateLayerDataFlag", true)
    },
    [allTypes.PASTE_LAYOUT_COL](state, data) {
      let rect = getAttrById(state, data, "rect").options
      if (data.elementInAutoLayoutId !== undefined) {
        rect = getAttrById(state, data, "elementInAutoLayout")
      }
      const useActiveIndex = rect?.categoryMode === CATEGORY_MODE.SAME ? 0 : rect.activeIndex
      const row_id = useActiveIndex
      let tempRect = [rect.rows[row_id]]
      handleFindLayoutComponentOptionsCols(tempRect, data.uid, (colsArr, tarColsIndex) => {
        const copyCol = JSON.parse(JSON.stringify(colsArr[tarColsIndex]))
        // deepChangeUid(copyCol)
        let layoutUidMap = deepChangeUid(copyCol)
        copyCol.uid =  layoutUidMap[copyCol.uid]
        colsArr.splice(tarColsIndex + 1, 0, copyCol)
        data.shareWidth &&
          colsArr.forEach(col => {
            Vue.set(col, "width", 100 / colsArr.length + "%")
          })
      })
      // 更新图层标志
      Vue.set(states, "isUpdateLayerDataFlag", true)
    },
    [allTypes.ADD_LAYOUT_COL](state, data) {
      let rect = getAttrById(state, data, "rect").options
      if (data.elementInAutoLayoutId !== undefined) {
        rect = getAttrById(state, data, "elementInAutoLayout")
      }
      const useActiveIndex = rect?.categoryMode === CATEGORY_MODE.SAME ? 0 : rect.activeIndex
      const row_id = useActiveIndex
      let tempRect = [rect.rows[row_id]]
      console.log("emptylayout_children :>> ", home[0].rows[0].cols[0])
      handleFindLayoutComponentOptionsCols(tempRect, data.uid, (colsArr, tarColsIndex) => {
        const copyCol = JSON.parse(JSON.stringify(home[0].rows[0].cols[0]))
        copyCol.uid = uuid.v1()
        // 编组的自由布局加列
        if (colsArr.length > 0 && colsArr[0].disableSetColAndRow) {
          copyCol.disableSetColAndRow = true
        }
        colsArr.splice(tarColsIndex + 1, 0, copyCol)
        data.shareWidth &&
          colsArr.forEach(col => {
            Vue.set(col, "width", 100 / colsArr.length + "%")
          })
      })
      Vue.set(rect.rows, row_id, tempRect[0])
      // 更新图层标志
      Vue.set(states, "isUpdateLayerDataFlag", true)
    },
    [allTypes.EXCHANGE_LAYOUT_COL](state, data) {
      let rect = getAttrById(state, data, "rect").options
      if (data.elementInAutoLayoutId !== undefined) {
        rect = getAttrById(state, data, "elementInAutoLayout")
      }
      const useActiveIndex = rect?.categoryMode === CATEGORY_MODE.SAME ? 0 : rect.activeIndex
      let tempRect = [rect.rows[useActiveIndex]]
      handleFindLayoutComponentOptionsCols(tempRect, data.uid, (colsArr, tarColsIndex, rowsArr, tarRowsIndex) => {
        let temp = colsArr[tarColsIndex]
        // 上下移动有问题，暂不处理
        switch (data.type) {
          // case "up":
          //   let colPath = findColPathByUid(tempRect[0], data.uid) || []
          //   let tarColInPath = colPath[colPath.length - 2]
          //   temp = tarColInPath.cols[tarColInPath.colId]
          //   Vue.set(tarColInPath.cols, tarColInPath.colId, tarColInPath.cols[tarColInPath.colId - 1])
          //   Vue.set(tarColInPath.cols, tarColInPath.colId - 1, temp)
          //   break
          // case "down":
          //   temp = rowsArr[tarRowsIndex]
          //   Vue.set(rowsArr, tarRowsIndex, rowsArr[tarRowsIndex + 1])
          //   Vue.set(rowsArr, tarRowsIndex + 1, temp)
          //   break
          case "prev":
            Vue.set(colsArr, tarColsIndex, colsArr[tarColsIndex - 1])
            Vue.set(colsArr, tarColsIndex - 1, temp)
            break
          case "next":
            Vue.set(colsArr, tarColsIndex, colsArr[tarColsIndex + 1])
            Vue.set(colsArr, tarColsIndex + 1, temp)
            break
          default:
        }
        // if (!data.type) {
        //   // 右移
        //   Vue.set(colsArr, tarColsIndex, colsArr[tarColsIndex + 1])
        //   Vue.set(colsArr, tarColsIndex + 1, temp)
        // } else {
        //   Vue.set(colsArr, tarColsIndex, colsArr[tarColsIndex - 1])
        //   Vue.set(colsArr, tarColsIndex - 1, temp)
        // }
      })
      // 更新图层标志
      Vue.set(states, "isUpdateLayerDataFlag", true)
    },
    [allTypes.UPDATE_COL_LEN_IN_LAYOUT](state, data) {
      let rect = getAttrById(state, data, "rect").options
      if (data.elementInAutoLayoutId !== undefined) {
        rect = getAttrById(state, data, "elementInAutoLayout")
      }
      const useActiveIndex = rect?.categoryMode === CATEGORY_MODE.SAME ? 0 : rect.activeIndex
      const row_id = useActiveIndex
      if (!rect.rows[row_id].cols[0].rows) {
        //如果为单列多行，则保存所有老单元格
        const oldColsData = rect.rows[row_id].cols
        //生成新的一行一列作为后续增加列的容器
        Vue.set(
          rect.rows,
          row_id,
          new LayoutGenerator({
            rows: [
              {
                height: "100%",
                cols: [
                  {
                    width: "100%",
                    componentBoxOptions: {
                      bgColor: "rgba(255,255,255,0)"
                    }
                  }
                ]
              }
            ]
          }).rows[0]
        )
        Vue.set(
          rect.rows[row_id].cols[0],
          "rows",
          new LayoutGenerator({
            rows: [
              {
                height: "100%",
                cols: [
                  {
                    width: "100%",
                    componentBoxOptions: {
                      bgColor: "rgba(255,255,255,0)"
                    }
                  }
                ]
              }
            ]
          }).rows
        )
        Vue.set(rect.rows[row_id].cols[0].rows[0], "cols", oldColsData)
      }
      let attr = rect.rows[row_id].cols[0]
      let editAttr = attr
      let editParent = null
      let editIndex = 0
      const regularResult = checkIrregularLayout(attr)
      const { rowLens, colLens } = regularResult
      if (data.editType === "cell") {
        // 操作一行一列的单元格，视为操作顶层容器
        if (rowLens === 1 && colLens === 1) {
          sessionStorage.setItem("willActiveUid", editAttr.uid)
        } else {
          ;[editAttr, editParent, editIndex] = handleFindLayoutByUid(attr, data.uid)
        }
      } else {
        editParent = rect.rows[row_id]
      }
      const historyLayoutType = findHistoryLayoutType(editAttr)[0]
      let layoutType = editAttr.componentBoxOptions.layoutType || historyLayoutType || data.layoutType
      // 兼容旧数据
      if (rect.menuName !== "手风琴图文" && data.type === "add" && editAttr.rows && !editAttr.rows[0].cols[0].rows) {
        layoutType = "col"
      }
      if (data.type === "add") {
        const addUids = JSON.parse(sessionStorage.getItem("addUids") || "[]")
        data.addLen = data.addLen || 1
        if (editAttr.rows) {
          if (layoutType === "row") {
            editAttr.rows.forEach((row, index) => {
              let parent = editAttr.componentBoxOptions.layoutType ? row.cols[0].rows[0] : row
              let useWidth = 0
              // 旧节点修改尺寸
              parent.cols.forEach(oldCol => {
                const oldWidth = Number(oldCol.width.replace("%", ""))
                const newWidth = Number(((oldWidth * (data.colsLen - data.addLen)) / data.colsLen).toFixed(2))
                useWidth += newWidth
                oldCol.width = `${newWidth}%`
              })
              // 如果单元格之前没有保存布局类型，将原始单元格包装一下
              if (!editAttr.componentBoxOptions.layoutType) {
                const topCol = new LayoutGenerator({
                  rows: [
                    {
                      height: "100%",
                      cols: [
                        {
                          width: "100%",
                          componentBoxOptions: {
                            bgColor: "rgba(255,255,255,0)"
                          },
                          rows: []
                        }
                      ]
                    }
                  ]
                }).rows[0].cols[0]
                topCol.rows = [
                  {
                    alginH: "center",
                    cols: [],
                    height: "100%",
                    margin: {}
                  }
                ]
                topCol.rows[0].cols.push(...parent.cols)
                editAttr.rows.splice(index, 1, {
                  alginH: "center",
                  cols: [topCol],
                  height: parent.height,
                  margin: {}
                })
                parent = topCol.rows[0]
              }
              // 新节点直接插入
              const restWidth = Number(((100 - useWidth) / data.addLen).toFixed(2))
              const config = {
                rows: [
                  {
                    height: "100%",
                    cols: []
                  }
                ]
              }
              for (let i = 0; i < data.addLen; i++) {
                config.rows[0].cols.push({
                  width: `${restWidth}%`,
                  componentBoxOptions: {
                    bgColor: "rgba(255,255,255,0)"
                  }
                })
              }
              const newLayout = new LayoutGenerator(config)
              const newCols = newLayout.rows[0].cols
              parent.cols.push(...newCols)
              const newUids = newCols.map(col => col.uid)
              addUids.push(...newUids)
            })
            editAttr.componentBoxOptions.layoutType = layoutType
          } else {
            let useWidth = 0
            let parent = null
            if (editAttr.rows.length === 1) {
              parent = editAttr.rows[0]
              // 旧节点修改尺寸
              parent.cols.forEach((oldCol, index) => {
                const oldWidth = Number(oldCol.width.replace("%", ""))
                const newWidth = Number(((oldWidth * (data.colsLen - data.addLen)) / data.colsLen).toFixed(2))
                useWidth += newWidth
                oldCol.width = `${newWidth}%`
                // 如果单元格之前没有保存布局类型，将原始单元格包装一下
                if (!editAttr.componentBoxOptions.layoutType) {
                  const topCol = new LayoutGenerator({
                    rows: [
                      {
                        height: "100%",
                        cols: [
                          {
                            width: "100%",
                            componentBoxOptions: {
                              bgColor: "rgba(255,255,255,0)"
                            },
                            rows: [{ alginH: "center", height: "100%" }]
                          }
                        ]
                      }
                    ]
                  }).rows[0].cols[0]
                  topCol.width = oldCol.width
                  oldCol.width = "100%"
                  topCol.rows = [
                    {
                      alginH: "center",
                      cols: [],
                      height: "100%",
                      margin: {}
                    }
                  ]
                  topCol.rows[0].cols.push(oldCol)
                  parent.cols.splice(index, 1, topCol)
                }
              })
            } else {
              const topCol = new LayoutGenerator({
                rows: [
                  {
                    height: "100%",
                    cols: [
                      {
                        width: "100%",
                        componentBoxOptions: {
                          bgColor: "rgba(255,255,255,0)"
                        },
                        rows: [{ alginH: "center", height: "100%" }]
                      }
                    ]
                  }
                ]
              }).rows[0].cols[0]
              topCol.width = editAttr.width
              const newWidth = Number(((100 * (data.colsLen - data.addLen)) / data.colsLen).toFixed(2))
              useWidth += newWidth
              editAttr.width = `${newWidth}%`
              topCol.rows = [
                {
                  alginH: "center",
                  cols: [],
                  height: "100%",
                  margin: {}
                }
              ]
              topCol.rows[0].cols.push(editAttr)
              parent = handleFindLayoutComponentColsParentRowByUid([rect.rows[row_id]], editAttr.uid)
              const index = parent.cols.indexOf(editAttr)
              parent.cols.splice(index, 1, topCol)
              parent = handleFindLayoutComponentColsParentRowByUid([rect.rows[row_id]], editAttr.uid)
              editAttr = topCol
            }
            // 生成新的列，插入父节点
            const restWidth = Number(((100 - useWidth) / data.addLen).toFixed(2))
            for (let i = 0; i < data.addLen; i++) {
              const newCol = new LayoutGenerator({
                rows: [
                  {
                    height: "100%",
                    cols: [
                      {
                        width: `${restWidth}%`,
                        componentBoxOptions: {
                          bgColor: "rgba(255,255,255,0)"
                        },
                        rows: []
                      }
                    ]
                  }
                ]
              }).rows[0].cols[0]
              const config = {
                rows: []
              }
              for (let i = 0; i < data.rowsLen; i++) {
                config.rows.push({
                  height: `${(100 / data.rowsLen).toFixed(2)}%`,
                  cols: [
                    {
                      width: "100%",
                      componentBoxOptions: {
                        bgColor: "rgba(255,255,255,0)"
                      }
                    }
                  ]
                })
              }
              const newRows = new LayoutGenerator(config)
              newCol.rows = newRows.rows
              parent.cols.push(newCol)
              const newUids = newCol.rows.map(row => row.cols[0].uid)
              addUids.push(...newUids)
            }
            editAttr.componentBoxOptions.layoutType = layoutType
          }
        } else {
          // 说明是叶子节点，把旧节点先存起来
          const oldCol = JSON.parse(JSON.stringify(editAttr))
          if (layoutType === "row") {
            const topCol = new LayoutGenerator({
              rows: [
                {
                  height: "100%",
                  cols: [
                    {
                      width: "100%",
                      componentBoxOptions: {
                        bgColor: "rgba(255,255,255,0)"
                      }
                    }
                  ]
                }
              ]
            }).rows[0].cols[0]
            const newRow = new LayoutGenerator({
              rows: [
                {
                  height: "100%",
                  cols: [
                    {
                      width: "100%",
                      componentBoxOptions: {
                        bgColor: "rgba(255,255,255,0)"
                      }
                    }
                  ]
                }
              ]
            }).rows[0]
            newRow.cols[0].rows = [
              {
                alginH: "center",
                cols: [],
                height: "100%",
                margin: {}
              }
            ]
            topCol.rows = [newRow]
            topCol.width = oldCol.width
            oldCol.width = (100 / data.colsLen).toFixed(2) + "%"
            newRow.cols[0].rows[0].cols.push(oldCol)
            for (let i = 0; i < data.addLen; i++) {
              const newCol = new LayoutGenerator({
                rows: [
                  {
                    height: "100%",
                    cols: [
                      {
                        width: `${(100 / data.colsLen).toFixed(2)}%`,
                        componentBoxOptions: {
                          bgColor: "rgba(255,255,255,0)"
                        }
                      }
                    ]
                  }
                ]
              }).rows[0].cols[0]
              newRow.cols[0].rows[0].cols.push(newCol)
              addUids.push(newCol.uid)
            }
            topCol.componentBoxOptions.layoutType = layoutType
            const idx = editParent.cols.indexOf(editAttr)
            editParent.cols.splice(idx, 1, topCol)
            sessionStorage.setItem("willActiveUid", topCol.uid)
          } else {
            const topCol = new LayoutGenerator({
              rows: [
                {
                  height: "100%",
                  cols: [
                    {
                      width: "100%",
                      componentBoxOptions: {
                        bgColor: "rgba(255,255,255,0)"
                      }
                    }
                  ]
                }
              ]
            }).rows[0].cols[0]
            topCol.width = oldCol.width
            topCol.rows = [
              {
                alginH: "center",
                cols: [],
                height: "100%",
                margin: {}
              }
            ]
            for (let i = 0; i < data.colsLen; i++) {
              const newCol = new LayoutGenerator({
                rows: [
                  {
                    height: "100%",
                    cols: [
                      {
                        width: `${(100 / data.colsLen).toFixed(2)}%`,
                        componentBoxOptions: {
                          bgColor: "rgba(255,255,255,0)"
                        },
                        rows: []
                      }
                    ]
                  }
                ]
              }).rows[0].cols[0]
              newCol.rows = [
                {
                  alginH: "center",
                  cols: [],
                  height: "100%",
                  margin: {}
                }
              ]
              if (i === 0) {
                oldCol.width = "100%"
                newCol.rows[0].cols.push(oldCol)
              } else {
                const col = new LayoutGenerator({
                  rows: [
                    {
                      height: "100%",
                      cols: [
                        {
                          width: "100%",
                          componentBoxOptions: {
                            bgColor: "rgba(255,255,255,0)"
                          }
                        }
                      ]
                    }
                  ]
                }).rows[0].cols[0]
                newCol.rows[0].cols.push(col)
                addUids.push(col.uid)
              }
              topCol.rows[0].cols.push(newCol)
            }
            topCol.componentBoxOptions.layoutType = layoutType
            const idx = editParent.cols.indexOf(editAttr)
            editParent.cols.splice(idx, 1, topCol)
            sessionStorage.setItem("willActiveUid", topCol.uid)
          }
        }
        sessionStorage.setItem("addUids", JSON.stringify(addUids))
      } else {
        data.subLen = data.subLen || 1
        const deleteUids = findDeleteLayout(editAttr, data.rowsLen, data.colsLen, layoutType)
        const layout = deleteLayout(attr, deleteUids)
        if (data.moveLastLeaf) {
          const lastLeaf = findLastLeafLayout(data.editType === "cell" ? editAttr : layout)
          if (data.editType === "cell") {
            sessionStorage.setItem("willActiveUid", lastLeaf.uid)
          }
          if (editAttr.uid === attr.uid) {
            Vue.set(rect.rows[row_id].cols, 0, lastLeaf)
          } else {
            lastLeaf.width = editParent.cols[editIndex].width
            Vue.set(editParent.cols, editIndex, lastLeaf)
          }
        } else {
          Vue.set(rect.rows[row_id].cols, 0, layout)
        }
      }
      // 更新图层标志
      Vue.set(states, "isUpdateLayerDataFlag", true)
    },
    [allTypes.UPDATE_ROW_LEN_IN_LAYOUT](state, data) {
      let rect = getAttrById(state, data, "rect").options
      if (data.elementInAutoLayoutId !== undefined) {
        rect = getAttrById(state, data, "elementInAutoLayout")
      }
      const useActiveIndex = rect?.categoryMode === CATEGORY_MODE.SAME ? 0 : rect.activeIndex
      const row_id = useActiveIndex
      if (!rect.rows[row_id].cols[0].rows) {
        //如果为单列多行，则保存所有老单元格
        const oldColsData = rect.rows[row_id].cols
        //生成新的一行一列作为后续增加列的容器
        Vue.set(
          rect.rows,
          row_id,
          new LayoutGenerator({
            rows: [
              {
                height: "100%",
                cols: [
                  {
                    width: "100%",
                    componentBoxOptions: {
                      bgColor: "rgba(255,255,255,0)"
                    }
                  }
                ]
              }
            ]
          }).rows[0]
        )
        Vue.set(
          rect.rows[row_id].cols[0],
          "rows",
          new LayoutGenerator({
            rows: [
              {
                height: "100%",
                cols: [
                  {
                    width: "100%",
                    componentBoxOptions: {
                      bgColor: "rgba(255,255,255,0)"
                    }
                  }
                ]
              }
            ]
          }).rows
        )
        Vue.set(rect.rows[row_id].cols[0].rows[0], "cols", oldColsData)
      }
      const attr = rect.rows[row_id].cols[0]
      let editAttr = attr
      let editParent = null
      let editIndex = 0
      const regularResult = checkIrregularLayout(attr)
      const { rowLens, colLens } = regularResult
      if (data.editType === "cell") {
        // 操作一行一列的单元格，视为操作顶层容器
        if (rowLens === 1 && colLens === 1) {
          sessionStorage.setItem("willActiveUid", editAttr.uid)
        } else {
          ;[editAttr, editParent, editIndex] = handleFindLayoutByUid(attr, data.uid)
        }
      }
      const historyLayoutType = findHistoryLayoutType(editAttr)[0]
      let layoutType = editAttr.componentBoxOptions.layoutType || historyLayoutType || data.layoutType
      // 兼容旧数据
      if (
        rect.menuName !== "手风琴图文" &&
        data.type === "add" &&
        editAttr.rows?.length === 1 &&
        !editAttr.rows[0].cols[0].rows
      ) {
        layoutType = "row"
      }
      if (data.type === "add") {
        const addUids = JSON.parse(sessionStorage.getItem("addUids") || "[]")
        data.addLen = data.addLen || 1
        if (editAttr.rows) {
          if (layoutType === "row") {
            let useHeight = 0
            // 旧节点修改大小尺寸
            editAttr.rows.forEach((oldRow, index) => {
              const oldHeight = Number(oldRow.height.replace("%", ""))
              const newHeight = Number(((oldHeight * (data.rowsLen - data.addLen)) / data.rowsLen).toFixed(2))
              useHeight += newHeight
              oldRow.height = `${newHeight}%`
              // 如果单元格之前没有保存布局类型，将原始单元格包装一下
              if (!editAttr.componentBoxOptions.layoutType) {
                const topRow = new LayoutGenerator({
                  rows: [
                    {
                      height: "100%",
                      cols: [
                        {
                          width: "100%",
                          componentBoxOptions: {
                            bgColor: "rgba(255,255,255,0)"
                          },
                          rows: []
                        }
                      ]
                    }
                  ]
                }).rows[0]
                topRow.height = oldRow.height
                oldRow.height = "100%"
                topRow.cols[0].rows.push(oldRow)
                editAttr.rows.splice(index, 1, topRow)
              }
            })
            // 新节点直接插入
            const restHeight = Number(((100 - useHeight) / data.addLen).toFixed(2))
            for (let i = 0; i < data.addLen; i++) {
              // 生成一个一行一列，作为行的容器
              const topRow = new LayoutGenerator({
                rows: [
                  {
                    height: `${restHeight}%`,
                    cols: [
                      {
                        width: "100%",
                        componentBoxOptions: {
                          bgColor: "rgba(255,255,255,0)"
                        },
                        rows: []
                      }
                    ]
                  }
                ]
              }).rows[0]
              const config = {
                rows: [
                  {
                    height: "100%",
                    cols: []
                  }
                ]
              }
              for (let j = 0; j < data.colsLen; j++) {
                config.rows[0].cols.push({
                  width: `${((1 / data.colsLen) * 100).toFixed(2)}%`,
                  componentBoxOptions: {
                    bgColor: "rgba(255,255,255,0)"
                  }
                })
              }
              const newCols = new LayoutGenerator(config).rows[0]
              topRow.cols[0].rows.push(newCols)
              editAttr.rows.push(topRow)
              const newUids = newCols.cols.map(col => col.uid)
              addUids.push(...newUids)
            }
            editAttr.componentBoxOptions.layoutType = layoutType
          } else {
            if (editAttr.rows.length === 1) {
              const parent = editAttr.rows[0]
              // 旧节点修改尺寸
              parent.cols.forEach(col => {
                let useHeight = 0
                const oldRows = col.rows
                oldRows.forEach(oldRow => {
                  const oldHeight = Number(oldRow.height.replace("%", ""))
                  const newHeight = Number(((oldHeight * (data.rowsLen - data.addLen)) / data.rowsLen).toFixed(2))
                  useHeight += newHeight
                  oldRow.height = `${newHeight}%`
                })
                // 新节点直接插入
                const restHeight = Number(((100 - useHeight) / data.addLen).toFixed(2))
                for (let i = 0; i < data.addLen; i++) {
                  const config = {
                    rows: [
                      {
                        height: `${restHeight}%`,
                        cols: []
                      }
                    ]
                  }
                  config.rows[0].cols.push({
                    width: "100%",
                    componentBoxOptions: {
                      bgColor: "rgba(255,255,255,0)"
                    }
                  })
                  const newLayout = new LayoutGenerator(config)
                  const newCol = newLayout.rows[0]
                  oldRows.push(newCol)
                  const newUids = newCol.cols.map(col => col.uid)
                  addUids.push(...newUids)
                }
              })
            } else {
              let parent = editAttr
              let useHeight = 0
              editAttr.rows.forEach(oldRow => {
                const oldHeight = Number(oldRow.height.replace("%", ""))
                const newHeight = Number(((oldHeight * (data.rowsLen - data.addLen)) / data.rowsLen).toFixed(2))
                useHeight += newHeight
                oldRow.height = `${newHeight}%`
              })
              // 如果单元格之前没有保存布局类型，将原始单元格包装一下
              if (!editAttr.componentBoxOptions.layoutType) {
                const topCol = new LayoutGenerator({
                  rows: [
                    {
                      height: "100%",
                      cols: [
                        {
                          width: "100%",
                          componentBoxOptions: {
                            bgColor: "rgba(255,255,255,0)"
                          },
                          rows: [{ alginH: "center", height: "100%" }]
                        }
                      ]
                    }
                  ]
                }).rows[0].cols[0]
                topCol.rows = [
                  {
                    alginH: "center",
                    cols: [],
                    height: "100%",
                    margin: {}
                  }
                ]
                topCol.rows[0].cols.push(editAttr)
                parent = handleFindLayoutComponentColsParentRowByUid([rect.rows[row_id]], editAttr.uid)
                const index = parent.cols.indexOf(editAttr)
                parent.cols.splice(index, 1, topCol)
                parent = handleFindLayoutComponentColsParentRowByUid([rect.rows[row_id]], editAttr.uid)
                editAttr = topCol
              }
              // 新节点直接插入
              const restHeight = Number(((100 - useHeight) / data.addLen).toFixed(2))
              for (let i = 0; i < data.addLen; i++) {
                const config = {
                  rows: [
                    {
                      height: `${restHeight}%`,
                      cols: []
                    }
                  ]
                }
                config.rows[0].cols.push({
                  width: "100%",
                  componentBoxOptions: {
                    bgColor: "rgba(255,255,255,0)"
                  }
                })
                const newCol = new LayoutGenerator(config).rows[0]
                parent.cols[0].rows.push(newCol)
                const newUids = newCol.cols.map(col => col.uid)
                addUids.push(...newUids)
              }
            }
            editAttr.componentBoxOptions.layoutType = layoutType
          }
        } else {
          // 说明是叶子节点，把旧节点先存起来
          const oldCol = JSON.parse(JSON.stringify(editAttr))
          if (layoutType === "row") {
            const topCol = new LayoutGenerator({
              rows: [
                {
                  height: "100%",
                  cols: [
                    {
                      width: "100%",
                      componentBoxOptions: {
                        bgColor: "rgba(255,255,255,0)"
                      },
                      rows: []
                    }
                  ]
                }
              ]
            }).rows[0].cols[0]
            topCol.width = oldCol.width
            for (let i = 0; i < data.rowsLen; i++) {
              const newRow = new LayoutGenerator({
                rows: [
                  {
                    height: `${(100 / data.rowsLen).toFixed(2)}%`,
                    cols: [
                      {
                        width: "100%",
                        componentBoxOptions: {
                          bgColor: "rgba(255,255,255,0)"
                        },
                        rows: []
                      }
                    ]
                  }
                ]
              }).rows[0]
              topCol.rows.push(newRow)
            }
            topCol.rows.forEach((row, index) => {
              row.cols[0].rows = [
                {
                  alginH: "center",
                  cols: [],
                  height: "100%",
                  margin: {}
                }
              ]
              const r = row.cols[0].rows[0]
              if (index === 0) {
                oldCol.width = "100%"
                r.cols.push(oldCol)
              } else {
                const newCol = new LayoutGenerator({
                  rows: [
                    {
                      height: "100%",
                      cols: [
                        {
                          width: `${(100 / data.colsLen).toFixed(2)}%`,
                          componentBoxOptions: {
                            bgColor: "rgba(255,255,255,0)"
                          }
                        }
                      ]
                    }
                  ]
                }).rows[0].cols[0]
                r.cols.push(newCol)
                addUids.push(newCol.uid)
              }
            })
            topCol.componentBoxOptions.layoutType = layoutType
            const idx = editParent.cols.indexOf(editAttr)
            editParent.cols.splice(idx, 1, topCol)
            sessionStorage.setItem("willActiveUid", topCol.uid)
          }
        }
        sessionStorage.setItem("addUids", JSON.stringify(addUids))
      } else {
        data.subLen = data.subLen || 1
        const deleteUids = findDeleteLayout(editAttr, data.rowsLen, data.colsLen, layoutType)
        const layout = deleteLayout(attr, deleteUids)
        if (data.moveLastLeaf) {
          const lastLeaf = findLastLeafLayout(data.editType === "cell" ? editAttr : layout)
          if (data.editType === "cell") {
            sessionStorage.setItem("willActiveUid", lastLeaf.uid)
          }
          if (editAttr.uid === attr.uid) {
            Vue.set(rect.rows[row_id].cols, 0, lastLeaf)
          } else {
            lastLeaf.width = editParent.cols[editIndex].width
            Vue.set(editParent.cols, editIndex, lastLeaf)
          }
        } else {
          Vue.set(rect.rows[row_id].cols, 0, layout)
        }
      }
      // 更新图层标志
      Vue.set(states, "isUpdateLayerDataFlag", true)
    },
    [allTypes.CHANGE_LAYOUT_ACTIVE](state, data) {
      if (
        Object.values(data).some(item => {
          return item === null
        })
      ) {
        throw new Error("Some data is null, its incomplete,found in state/stage/mutations/CHANGE_LAYOUT_ACTIVE")
      }
      let temRect = getAttrById(state, data, "rect")?.options
      if (data.elementInAutoLayoutId !== undefined && temRect) {
        temRect = getAttrById(
          state,
          {
            container_id: data.container_id,
            rect_id: data.rect_id,
            elementInAutoLayoutId: data.elementInAutoLayoutId,
            path: data.path
          },
          "elementInAutoLayout"
        )
      }
      if ((data.container_id || data.container_id === 0) && temRect && temRect.rows) {
        const row_id = temRect.activeIndex
        const useActiveIndex = temRect?.categoryMode === CATEGORY_MODE.SAME ? 0 : row_id
        let tempRect = [temRect.rows[useActiveIndex]]
        handleFindLayoutComponentOptions(tempRect, data.uid, colsItem => {
          if (Array.isArray(colsItem.elementOptions)) {
            colsItem.elementOptions.some(item => {
              if (data.option_val === "delAllActive") {
                Vue.set(item, data.option_name, false)
              } else {
                if (data.elementInLayoutId == item.elementInLayoutId) {
                  Vue.set(item, data.option_name, data.option_val)
                  return true
                }
              }
            })
          }
        })
      }
    },
    [allTypes.INIT_LAYOUT_COMPONENT](state, data) {
      const temRect = getAttrById(state, data.ids).options
      const row_id = temRect.categoryMode === CATEGORY_MODE.SAME ? 0 : temRect.activeIndex
      const rect = getAttribute(state, data.ids).options
      Vue.set(rect.rows, row_id, data.rowData)
    },
    [allTypes.CHANGE_LAYOUT_TITLE_ElEMENT](state, payload) {
      let temRect = getAttrById(state, payload, "rect").options
      if (payload.elementInAutoLayoutId !== undefined) {
        temRect = getAttrById(state, payload, "elementInAutoLayout")
      }
      Vue.set(temRect.titleOptions[payload.directionIndex], payload.option_name, payload.option_val)
    },
    [allTypes.CHANGE_LAYOUT_TITLE_OPTIONS](state, payload) {
      let options = getAttrById(state, payload, "rect").options
      if (payload.elementInAutoLayoutId !== undefined) {
        options = getAttrById(state, payload, "elementInAutoLayout")
      }
      let tempRect = options.titleOptions[payload.directionIndex]?.elementOptions.find(
        it => it.elementInLayoutId === payload.elementInLayoutId
      )?.options
      tempRect && changeOption(tempRect, payload)
    },
    [allTypes.CHANGE_LAYOUT_TITLE_ACTIVE](state, payload) {
      let rect = getAttrById(state, payload, "rect").options
      if (payload.elementInAutoLayoutId !== undefined) {
        rect = getAttrById(state, payload, "elementInAutoLayout")
      }
      rect.titleOptions[payload.directionIndex].elementOptions.find(
        it => it.elementInLayoutId === payload.elementInLayoutId
      ).isActive = true
    },
    [allTypes.CHANGE_LAYOUT_TITLE_DISABLE_ACTIVE](state, payload) {
      let temRect = getAttrById(state, payload, "rect").options
      if (payload.elementInAutoLayoutId !== undefined) {
        temRect = getAttrById(state, payload, "elementInAutoLayout")
      }
      if (
        temRect.titleOptions[payload.directionIndex].elementOptions.find(
          it => it.elementInLayoutId === payload.elementInLayoutId
        )
      ) {
        temRect.titleOptions[payload.directionIndex].elementOptions.find(
          it => it.elementInLayoutId === payload.elementInLayoutId
        ).isActive = false
      }
    },
    [allTypes.CHANGE_LAYOUT_TITLE_COMPONENT_DISPLAY_HANDLE](state, payload) {
      let temRect = getAttrById(state, payload, "rect").options
      if (payload.elementInAutoLayoutId !== undefined) {
        temRect = getAttrById(state, payload, "elementInAutoLayout")
      }
      let titleOptions = temRect.titleOptions[payload.directionIndex]
      if (!titleOptions) {
        return
      }
      // todo 优化成不是默认组件则进行删除，否则是改变isShow 状态
      let handleRect = titleOptions.elementOptions.find(it => it.elementInLayoutId === payload.elementInLayoutId)
      if (handleRect.innerElement === "emptyLayoutComponent") {
        const _index = titleOptions.elementOptions.findIndex(it => it.elementInLayoutId === payload.elementInLayoutId)
        _index !== -1 && titleOptions.elementOptions.splice(_index, 1)
      } else {
        titleOptions.elementOptions.find(it => it.elementInLayoutId === payload.elementInLayoutId).isShow =
          payload.value
      }
      // 表示正在删除或者隐藏子页面面包屑
      if (
        state.type === "listPage" &&
        (handleRect.innerElement === "cxNavMenuVertical" || handleRect.innerElement === "cxBreadCrumbs") &&
        !payload.value
      ) {
        const appId = this.state.states.getDataPageIds.appId
        const requestPrefix = location.pathname.indexOf("appHome") > -1 ? "appStage" : "stage"
        let subPage = localStorage.getItem("subPageSetting-" + appId + "-" + requestPrefix)
        if (!subPage) {
          return
        }
        subPage = JSON.parse(subPage)
        if(handleRect.innerElement === "cxNavMenuVertical") {
          subPage.listPageSetting.showNavMenu = payload.value
        }
        if(handleRect.innerElement === "cxBreadCrumbs") {
          subPage.listPageSetting.showBreadCrumbs = payload.value
        }
        localStorage.setItem("subPageSetting-" + appId + "-" + requestPrefix, JSON.stringify(subPage))
        sessionStorage.setItem("isSubComponentDeleting", 1)
      }
    },
    [allTypes.CHANGE_LAYOUT_TITLE_DISPLAY_SHOW](state, payload) {
      let temRect = getAttrById(state, payload, "rect").options
      if (payload.elementInAutoLayoutId !== undefined) {
        temRect = getAttrById(state, payload, "elementInAutoLayout")
      }
      if (
        temRect.titleOptions[payload.directionIndex].elementOptions.find(
          it => it.elementInLayoutId === payload.elementInLayoutId
        ).isShow == true
      ) {
        temRect.titleOptions[payload.directionIndex].elementOptions.find(
          it => it.elementInLayoutId === payload.elementInLayoutId
        ).isShow = false
      } else {
        temRect.titleOptions[payload.directionIndex].elementOptions.find(
          it => it.elementInLayoutId === payload.elementInLayoutId
        ).isShow = true
      }
    },
    [allTypes.CHANGE_LAYOUT_TITLE_DISPLAY](state, payload) {
      let temRect = getAttrById(state, payload, "rect").options
      if (payload.elementInAutoLayoutId !== undefined) {
        temRect = getAttrById(state, payload, "elementInAutoLayout")
      }
      let temp = {
        ...temRect.titleOptions[payload.directionIndex].elementOptions.find(
          it => it.elementInLayoutId === payload.elementInLayoutId
        )
      }
      temp.options.left = 0
      temp.options.top = 0
      let _index = temRect.titleOptions[payload.directionIndex].elementOptions.findIndex(
        it => it.elementInLayoutId === payload.elementInLayoutId
      )
      temRect.titleOptions[payload.directionIndex].elementOptions.splice(_index, 1)
      temRect.titleOptions[
        payload.position == "top" ? 0 : payload.position == "bottom" ? 1 : payload.position == "left" ? 2 : 3
      ].elementOptions.push(temp)
    },
    [allTypes.SWIPER_CONTENT_CONTROL](state, data) {
      let tempRect = getAttrById(state, data, "rect").options
      if (data.elementInAutoLayoutId !== undefined) {
        tempRect = getAttrById(state, data, "elementInAutoLayout")
      }
      if (data.mode === "add") {
        const param = { ...tempRect.content[tempRect.content.length - 1] }
        let options = param.elementOptions || []
        param.elementOptions = JSON.parse(JSON.stringify(options))
        param.swiperContent_id++
        tempRect.content.push(param)
      } else if (data.mode === "del") {
        //删除指定轮播页
        const newVal = tempRect.content.filter(item => item.swiperContent_id !== data.swiperContent_id)
        tempRect.content = newVal
        event.deleteEventByDep({ ...data }, "delSwiperContent")
      } else if (data.mode === "updateMul") {// 根据数据渲染轮播页
        const dataLength = data.number //数据长度
        let slideLength = tempRect?.content?.length //轮播页个数
        if (dataLength && dataLength !== -1) {
          if (dataLength < slideLength) {// 删除
            for (let i = slideLength - 1; i > dataLength - 1; i--) {
              event.deleteEventByDep(
                { ...data, swiperContent_id: tempRect.content[i].swiperContent_id },
                "delSwiperContent"
              )
            }
            tempRect.content = tempRect.content.slice(0, dataLength)
          }
          if (dataLength > slideLength) {// 新增
            for (let i = slideLength; i < dataLength; i++) {
              const param = { ...tempRect.content[tempRect.content.length - 1] }
              let options = param.elementOptions || []
              param.elementOptions = JSON.parse(JSON.stringify(options))
              param.swiperContent_id++
              tempRect.content.push(param)
            }
          }

        }
      } else {
        event.deleteEventByDep(
          { ...data, swiperContent_id: tempRect.content.pop().swiperContent_id },
          "delSwiperContent"
        )
      }
    },
    [allTypes.SWIPER_CONTENT_OPTIONS_UPDATE](state, data) {
      let tempRect = getAttrById(state, data, "rect").options
      if (data.elementInAutoLayoutId !== undefined) {
        tempRect = getAttrById(state, data, "elementInAutoLayout")
      }
      tempRect = tempRect.content[data.swiperContent_id].options
      Vue.set(tempRect, "detailsPageTarget", data.content)
    },
    [allTypes.SWIPER_CONTENT_UPDATE](state, data) {
      let tempRect = getAttrById(state, data, "rect").options
      if (data.elementInAutoLayoutId !== undefined) {
        tempRect = getAttrById(state, data, "elementInAutoLayout")
      }
      // 处理单元格同步之后 动画对应uid的修改
      swiperColAnimateSync(data)
      tempRect = tempRect.content[data.swiperContent_id]
      Vue.set(tempRect, "elementOptions", data.content.elementOptions)
      Vue.set(tempRect, "options", data.content.options)
    },
    [allTypes.CHANGE_OPTION](state, data) {
      // console.log("CHANGE_OPTION", data)
      if (data.rect_id === null || typeof data.rect_id === "undefined") {
        if (
          data.hasOwnProperty("pageLayoutId") &&
          data.pageLayoutId !== null &&
          typeof data.pageLayoutId !== "undefined"
        ) {
          changeOption(getAttrById(state, data, "pageLayout")?.options, data)
          return
        }
        //修改老画布设置的时候
        let tempRect
        if (getAttrById(state, data, "container")?.hasOwnProperty("options")) {
          tempRect = getAttrById(state, data, "container").options
        } else {
          tempRect = {}
        }
        changeOption(tempRect, data)
      } else if (
        isExist(data.elementInAutoLayoutId) &&
        isExist(data.directionIndex) &&
        isExist(data.elementInLayoutId)
      ) {
        let options = getAttrById(state, data)?.titleOptions[data.directionIndex].elementOptions.find(
          it => it.elementInLayoutId === data.elementInLayoutId
        )?.options
        changeOption(options, data)
      } else if ((isExist(data.uid) && isExist(data.elementInLayoutId)) || isExist(data.elementInAutoLayoutId)) {
        // 为了解决在自由布局内组件修改属性失败的问题
        changeOption(getAttrById(state, data), data)
      } else {
        // console.log("data",data)
        changeOption(getAttrById(state, data)?.options, data)
      }
    },
    [allTypes.CHANGE_OPTIONS](state, data) {
      let rectAttr = getAttrById(state, data, "rect").options //所在的自由布局
      let autoAttr = undefined // 当前元素
      if (data.elementInAutoLayoutId !== undefined) {
        if (data.uid !== undefined) {
          // 自由布局内
          if (rectAttr.innerElement === "cxAutoLayout") {
            // 在自动布局的自由布局下
            rectAttr = getAttrById(state, { ...data, uid: undefined }, "elementInAutoLayout")
            autoAttr = getAttrById(state, data, "autoLayout")
          } else {
            rectAttr = getAttrById(state, data, "autoLayout") // 在自由布局的自动布局下
            autoAttr = getAttrById(state, data, "elementInAutoLayout")
          }
        } else if (isExist(data.directionIndex)) {
          rectAttr = getAttrById(state, data)
          autoAttr = rectAttr?.titleOptions[data.directionIndex].elementOptions.find(
            it => it.elementInLayoutId === data.elementInLayoutId
          )
        } else {
          rectAttr = getAttrById(state, data, "autoLayout")
          autoAttr = rectAttr?.elementOptions?.find(it => it.elementInAutoLayoutId === data.elementInAutoLayoutId)
        }
      } else {
        autoAttr = getAttrById(state, data)
      }
      const opt = autoAttr.options ? autoAttr.options : autoAttr
      const rectShape = opt.innerElement ? opt.innerElement.toLowerCase() : ""
      // 样式切换的时候 修改动画对用的id
      copyAnimateRelation(
        state,
        {
          options: data.options,
          shape: data.options.shape
        },
        data.options.rect_id, //旧的rectId
        data.rect_id // 新的rectId
      )
      if (
        !data.isEditEvent &&
        (data.options.innerElement !== opt.innerElement || rectShape.includes("layout") || rectShape.includes("swiper"))
      ) {
        //如果组件的类型发生了改变或者是在改轮播、自由布局这中容器组件时，需要清理当前组件的事件
        event.deleteEventByDep(data, rectShape)
      }
      if (typeof data.options.event === "object") {
        event.mergeEvent(
          {
            options: data.options,
            ids: {
              container_id: data.container_id,
              rect_id: data.rect_id
            }
          },
          "rect"
        )
      }
      if (data.uid && rectAttr.innerElement === "emptyLayoutComponent") {
        // 选中的是布局里面的某个组件
        //需要删除对应组件事件
        const useActiveIndex = rectAttr.categoryMode === CATEGORY_MODE.SAME ? 0 : rectAttr.activeIndex
        let activeNodes = rectAttr.rows[useActiveIndex]
        let findResult = findPathByLeafId(data.uid, activeNodes)
        let tempRect, selectIndex
        if (findResult)
          findResult.elementOptions.forEach((element, index) => {
            if (element.elementInLayoutId === data.elementInLayoutId) {
              tempRect = JSON.parse(JSON.stringify(data.options))
              tempRect.elementInLayoutId = data.elementInLayoutId
              selectIndex = index
            }
          })
        Vue.set(findResult.elementOptions, selectIndex, tempRect)
      } else if (
        data.hasOwnProperty("elementInAutoLayoutId") &&
        typeof Number(data.elementInAutoLayoutId) &&
        rectAttr.innerElement === "cxAutoLayout"
      ) {
        let index = rectAttr.elementOptions.findIndex(it => it.elementInAutoLayoutId === data.elementInAutoLayoutId)
        let tempRect = JSON.parse(JSON.stringify(data.options))
        tempRect.elementInAutoLayoutId = data.elementInAutoLayoutId
        Vue.set(rectAttr.elementOptions, index, tempRect)
      } else if (data.hasOwnProperty("directionIndex") && typeof Number(data.directionIndex)) {
        if (autoAttr.options) {
          const elementInLayoutId = autoAttr.options.elementInLayoutId
          data.options.elementInLayoutId = elementInLayoutId
          Vue.set(autoAttr, "options", data.options)
        }
      } else if (data.hasOwnProperty("elementInSwiperId") && data.elementInSwiperId !== null) {
        //选中的是轮播里的某个组件
        const attr = getAttrById(state, data, "elementInSwiper")
        Object.keys(data.options).forEach(key => {
          Vue.set(attr, key, data.options[key])
        })
      } else if (data.hasOwnProperty("rect_id") && data.rect_id !== null) {
        // 这个属性用来 判断是否是切换了样式（自由布局），需要重新计算自由布局的行，列数
        data.options.reload = true
        Vue.set(getAttrById(state, data, "rect"), "options", data.options)
      } else {
        Vue.set(getAttrById(state, data, "container"), "options", data.options)
      }
    },
    [allTypes.CHANGE_STORE_OPTIONS](state, data) {
      const rectAttr = getAttrById(state, data, "")
      if (!rectAttr.storeOptions) {
        Vue.set(rectAttr, "storeOptions", {})
      }
      if (!data.options) {
        Vue.delete(rectAttr.storeOptions, data.classify)
      } else {
        Vue.set(rectAttr.storeOptions, data.classify, data.options)
      }
    },
    [allTypes.CHANGE_STORE_OPTIONS_NEW](state, data) {
      const rectAttr = getAttrById(state, data, "")
      const _options =  rectAttr.options || rectAttr
      Vue.set(_options, data.classify, data.options)
    },
    [allTypes.INIT_STORE_OPTIONS](state, data) {
      const rectAttr = getAttrById(state, data, "").options
      Vue.set(rectAttr, "storeOptions", data.options)
    },
    // ======================================
    [allTypes.DEL_OPTION_CONTENT](state, data) {
      if (data.uid === null) {
        getAttrById(state, data, "rect").options.content.splice(data.start_id, 1)
      } else {
        const rectAttr = getAttrById(state, data, "rect")
        const row_id = rectAttr.options.categoryMode === CATEGORY_MODE.SAME ? 0 : rectAttr.options.activeIndex
        let tempRect = [JSON.parse(JSON.stringify(rectAttr.options.rows[row_id]))]
        handleFindLayoutComponentOptions(tempRect.rows, data.uid, colsItem => {
          colsItem.elementOptions.content.splice(data.start_id, 1)
        })
        Vue.set(rectAttr.options.rows, row_id, tempRect[0])
      }
    },
    [allTypes.ELEMENT_ADD](state, data) {
      if (data.uid && data.curCol) {
        Vue.set(getAttrById(state, data, "rect").options, "rows", data.curCol)
        return
      }

      const allRects = getAttrById(state, data, "container").children
      let _rect_id = -1
      if (allRects.length > 0) {
        _rect_id = smartMathMax(
          ...allRects.filter(item => typeof item.rect_id === 'number').map(function (o) {
            return o.rect_id
          })
        )
      }
      if (!data.ignoreAnimate) {
        // 新加入的组件，只要有动画，则需要重新匹配动画关系
        copyAnimateRelation(state, data.data, data.data.rect_id, _rect_id + 1)
      }
      data.data.rect_id = data.data.options.inSubHead ? data.data.rect_id : _rect_id + 1
      event.mergeEvent(
        {
          options: data.data.options,
          ids: {
            container_id: data.containerID,
            rect_id: data.data.rect_id
          }
        },
        "rect"
      )
      getAttrById(state, data, "container").children.push(data.data)
      //新增元素更新图层数据
      Vue.set(states, "isUpdateLayerDataFlag", true)
      if (data.inHead) {
        const headLayout = state.page.pageLayoutList.find(pageLayout => pageLayout.options.inDocument === "header")
        if (headLayout && headLayout.options.headComponentMap) {
          const rect = data.data
          const headComponentMap = headLayout.options.headComponentMap
          if (
            Array.isArray(rect.options.pluginName) &&
            rect.options.pluginName.includes("loginLayoutComponent") &&
            headComponentMap.login === ""
          ) {
            headComponentMap.login = rect.rect_id
          }
          if (rect.shape === "imageComponent" && headComponentMap.logo === "") {
            headComponentMap.logo = rect.rect_id
          }
          if (rect.shape === "cxNavMenu" && headComponentMap.nav === "") {
            headComponentMap.nav = rect.rect_id
          }
        }
      }
    },
    [allTypes.ELEMENT_DELETE](state, data) {
      const container = getAttrById(state, data, "container")
      const rect_id = data.hasOwnProperty("rectId") ? data.rectId : data.rect_id
      const isBigScreenPreview = (window.previewUrl || location.href).includes("bigScreenPreview")
      //在新版布局的通栏中 如果当前删除的这个组件是预设的有响应式效果的组件
      if (state.page.pageLayoutList) {
        const headLayout =
          state.page.pageLayoutList[0].options.inDocument === "header" ? state.page.pageLayoutList[0] : null
        if (headLayout && headLayout.options.headComponentMap) {
          if (!isBigScreenPreview) {
            //检查当前组件是否在头部通栏中被绑定了
            const headComponentMap = headLayout.options.headComponentMap
            let replaceKey = ""
            for (let i in headComponentMap) {
              if (headComponentMap[i] === rect_id) {
                headComponentMap[i] = ""
                replaceKey = i
              }
            }
            // 删除头部绑定组件时，需要寻找另外符合要求的组件绑定
            if (replaceKey) {
              const headRectId = getAllRectInNewLayout([headLayout])
                .map(it => it.rects || [])
                .flat(1)
              const rects = container.children.filter(
                item => item.rect_id !== rect_id && headRectId.includes(item.rect_id)
              )
              if (replaceKey === "login") {
                const loginRect = findRectPath(rects, "login")
                if (loginRect) {
                  headComponentMap[replaceKey] = loginRect.rect_id
                }
              }
              if (replaceKey === "logo") {
                const logoRect = findRectPath(rects, "logo")
                if (logoRect) {
                  headComponentMap[replaceKey] = logoRect.rect_id
                }
              }
              if (replaceKey === "nav") {
                const navRect = findRectPath(rects, "nav")
                if (navRect) {
                  headComponentMap[replaceKey] = navRect.rect_id
                }
              }
            }
          }
        }
      }
      const allRect = container.children
      const rectIndex = allRect.findIndex(it => it.rect_id === rect_id)
      if (rectIndex === -1) return //组件找不到 则退出
      //删除组件内的组件同时 需要删除该组件的事件（如果有事件的话）
      event.deleteEventByDep(data, allRect[rectIndex].options.innerElement)
      // 删除组件的时候，删除对应的动画关系
      delAnimateInRect(state, data, allRect[rectIndex])
      //处理删除逻辑
      allRect.splice(rectIndex, 1)
      // 更新图层标志
      Vue.set(states, "isUpdateLayerDataFlag", true)

      // 更新页面布局对应的rectId
      let pageLayoutList = state.page.pageLayoutList || []
      pageLayoutList.forEach(item => {
        // 新的画布模式
        if (item.options.canvasOptions) {
          let rectIds = item.options.canvasOptions.rectsId
          let _index = rectIds.indexOf(rect_id)
          if (_index > -1) {
            rectIds.splice(_index, 1)
          }
        } else {
          delLayoutRectId(item.layout)
          // 删除横向标签布局下的组件 需要再往下查找一层
          let rectIds = item.layout?.rows[0]?.rectIds
          if (rectIds && rectIds[0]) {
            const component = getAttrById(state, {
              container_id: data.container_id,
              rect_id: rectIds[0]
            }, "rect")
            if (component.shape === "cxPageLayoutComponent") {
              delLayoutRectId(component.options?.layout?.layout)
            }
          }
        }
      })
      function delLayoutRectId(layout) {
        let hasDel = false
        layout.cols?.forEach(item => {
          let _index = item.rectIds.indexOf(rect_id)
          if (_index > -1) {
            hasDel = true
            item.rectIds.splice(_index, 1)
          } else {
            delLayoutRectId(item.layout)
          }
        })
        if (hasDel) {
          return
        }
        layout.rows?.forEach(item => {
          let _index = item.rectIds.indexOf(rect_id)
          if (_index > -1) {
            item.rectIds.splice(_index, 1)
          } else {
            delLayoutRectId(item.layout)
          }
        })
      }
    },

    [allTypes.CONTAINER_DELETE](state, container_id) {
      const container = state.page.children
      const delIndex = container.findIndex(it => it.container_id === container_id)
      const rects = container[delIndex]
      //删除图层时同情空图层当中的组件的时间发布和事件响应
      rects.children.forEach(rect => {
        event.deleteEventByDep(
          {
            container_id: container_id,
            rect_id: rect.rect_id
          },
          rects.options.innerElement
        )
      })
      container.splice(delIndex, 1)
      if (state.page.stageType !== "layOut") {
        let newTotalHeight = 0
        container.forEach(containerItem => {
          if (containerItem.options && containerItem.options.isFixed) {
            return
          }
          newTotalHeight += Number(containerItem.height)
        })
        Vue.set(state.page, "height", newTotalHeight)
      }
      // 更新图层标志
      Vue.set(states, "isUpdateLayerDataFlag", true)
    },
    [allTypes.ENABLE_ACTIVE](state, payload) {
      getAttrById(state, payload, "rect").active = true
    },
    [allTypes.DISABLE_ACTIVE](state, payload) {
      if (
        getAttrById(state, payload, "container") &&
        getAttrById(state, payload, "container").children.length >= 1 &&
        getAttrById(state, payload, "rect")
      ) {
        getAttrById(state, payload, "rect").active = false
      }
    },
    [allTypes.CHANGE_HEIGHT](state, payload) {
      getAttrById(state, payload, "rect").options.height = payload.height
    },
    [allTypes.CHANGE_WIDTH](state, payload) {
      getAttrById(state, payload, "rect").options.width = payload.width
    },
    [allTypes.CHANGE_TOP](state, payload) {
      getAttrById(state, payload, "rect").options.top = payload.top
    },
    [allTypes.CHANGE_LEFT](state, payload) {
      getAttrById(state, payload, "rect").options.left = payload.left
    },
    [allTypes.CHANGE_DRAGGABLE](state, payload) {
      if (
        payload.hasOwnProperty("elementInLayoutId") &&
        payload.elementInLayoutId !== null &&
        typeof payload.elementInLayoutId !== "undefined"
      ) {
        getAttrById(state, payload).draggable = payload.flag
        getAttrById(state, payload).draggableTemp = !payload.flag
      } else {
        getAttrById(state, payload, "rect").draggable = payload.flag
        getAttrById(state, payload, "rect").draggableTemp = !payload.flag
      }
    },
    [allTypes.CHANGE_DATASOURCE](state, payload) {
      state.page = payload
    },
    [allTypes.CHANGE_TABS_ACTIVE_INDEX](state, payload) {
      let options = getAttrById(state, payload, "rect").options
      if (payload.elementInAutoLayoutId !== undefined) {
        let data = JSON.parse(JSON.stringify(payload))
        if (data.hasOwnProperty("elementInLayoutId")) delete data.elementInLayoutId
        options = getAttrById(state, data, "elementInAutoLayout")
      }
      if (payload.singleTabs && options.innerElement === "emptyLayoutComponent") {
        // 判断是否是搜索布局组件中的单选和tab
        // 不在组件中 不需要切换容器
        let cols = options.rows[0].cols
        let elementOptions = cols
          .find(item => item.uid === payload.uid)
          .elementOptions.find(item => item.elementInLayoutId == payload.elementInLayoutId)
        Vue.set(elementOptions, "activeIndex", payload.activeIndex)
      } else if (payload.isPageLayoutTabs) {
        // 判断是否是通栏中横向标签布局
        Vue.set(options, "activeIndex", payload.activeIndex)
        if (typeof payload.parentRectId === "undefined" || payload.parentRectId === null) {
          const curIndex = findCurrentComponentPathInLayoutByRectId(state.page.pageLayoutList, payload.rect_id)[0]
          let data = {
            container_id: payload.container_id,
            pageLayoutId: curIndex
          }
          let tempPageLayout = getAttrById(state, data, "pageLayout")
          Vue.set(tempPageLayout.options, "activeIndex", payload.activeIndex)
        } else {
          //  新模式-布局组件内的tab组件
          let tempRect = getAttrById(
            state,
            {
              container_id: payload.container_id,
              rect_id: payload.parentRectId
            },
            "rect"
          )
          Vue.set(tempRect.options.layout.options, "activeIndex", payload.activeIndex)
        }
      } else {
        Vue.set(options, "activeIndex", payload.activeIndex)
        Vue.set(
          options.titleOptions[payload.directionIndex].elementOptions.find(
            it => it.elementInLayoutId === payload.elementInLayoutId
          ).options,
          "activeIndex",
          payload.activeIndex
        )
      }
    },
    [allTypes.CHANGE_ANCHOR_ACTIVE_INDEX](state, payload) {
      let options = getAttrById(state, payload, "rect").options
      if (payload.elementInAutoLayoutId !== undefined) {
        let data = simpleDeepClone(payload)
        if (data.hasOwnProperty("elementInLayoutId")) {
          delete data.elementInLayoutId
        }
        options = getAttrById(state, data, "elementInAutoLayout")
      }
      Vue.set(options, "activeIndex", payload.activeIndex)
    },
    [allTypes.CHANGE_TABS_TITLE](state, payload) {
      let options = getAttrById(state, payload, "rect").options
      if (payload.elementInAutoLayoutId !== undefined) {
        options = getAttrById(state, payload, "elementInAutoLayout")
      }
      Vue.set(
        options.titleOptions[payload.directionIndex].elementOptions.find(
          it => it.elementInLayoutId === payload.elementInLayoutId
        ).options,
        "tabsList",
        payload.tabsList
      )
    },
    [allTypes.CHANGE_TAB_MAP_ROW_CONTENT](state, payload) {
      console.log("payload.content", payload.content)
      let options = getAttrById(state, payload, "rect").options
      if (payload.elementInAutoLayoutId !== undefined) {
        options = getAttrById(state, payload, "elementInAutoLayout")
      }
      Vue.set(options.rows, payload.index, payload.content)
    },
    [allTypes.CHANGE_TABS_ORDER](state, payload) {
      if (payload.hasOwnProperty("directionIndex") && typeof Number(payload.directionIndex)) {
        // 在自由布局中
        let options = getAttrById(state, payload, "rect").options
        if (payload.elementInAutoLayoutId !== undefined) {
          options = getAttrById(state, payload, "elementInAutoLayout")
        }
        let rows = options.rows
        rows.splice(payload.newIndex, 0, ...rows.splice(payload.oldIndex, 1))
      } else if (payload.isPageLayoutTabs) {
        let tempPageLayout
        if(isExist(payload.parentRectId)){
          // 栅格模式
          const curIndex = findCurrentComponentPathInLayoutByRectId(state.page.pageLayoutList, payload.parentRectId)[0]
          let data = {
            container_id: payload.container_id,
            rect_id:payload.parentRectId,
          }
           tempPageLayout = getAttrById(state, data)?.options.layout
        }else {
          const curIndex = findCurrentComponentPathInLayoutByRectId(state.page.pageLayoutList, payload.rect_id)[0]
          let data = {
            container_id: payload.container_id,
            pageLayoutId: curIndex
          }
           tempPageLayout = getAttrById(state, data, "pageLayout")
        }
        if (tempPageLayout?.options?.isShowVerticalTabs) {
          // 纵向标签布局
          let cols = tempPageLayout.layout.rows[0].layout.rows[0].layout.cols[1].layout.cols
          cols.splice(payload.newIndex, 0, ...cols.splice(payload.oldIndex, 1))
        } else {
          // 横向标签布局
          let rows = tempPageLayout.layout.rows[0].layout.rows[1].layout.rows
          rows.splice(payload.newIndex, 0, ...rows.splice(payload.oldIndex, 1))
        }
      }
    },
    /**
     * 容器事件
     */
    [allTypes.ENABLE_CONTAINER_ACTIVE](state, payload) {
      Vue.set(getAttrById(state, payload, "container"), "isActive", true)
    },
    [allTypes.DISABLE_CONTAINER_ACTIVE](state, payload) {
      Vue.set(getAttrById(state, payload, "container"), "isActive", false)
    },
    [allTypes.INSERT_CONTAINER](state, data) {
      const container = state.page.children
      data.container_data.container_id =
        new Array(container.length)
          .fill(1)
          .map((it, index) => (it = { container_id: container[index].container_id }))
          .sort((c, n) => n.container_id - c.container_id)[0].container_id + 1
      if (data.hasOwnProperty("id")) {
        //有id，说明是在非布局模式中新增画布 需要splice到具体位置
        const _start = container.findIndex(it => it.container_id === data.id)
        container.splice(_start + 1, 0, data.container_data)
      } else {
        //布局模式 位置不影响 containerid对了就行 直接push
        container.push(data.container_data)
      }
      data.container_data.children.forEach(rect => {
        handleChildAppid(
          rect,
          data.container_data.container_id,
          {
            container_id: data.container_data.container_id,
            rect_id: rect.rect_id
          },
          true
        )
      })
      if (state.page.stageType !== "layOut") {
        //非布局模式才需要更新页面高度
        let newTotalHeight = 0
        container.forEach(containerItem => {
          if (containerItem.options && containerItem.options.isFixed) {
            return
          }
          newTotalHeight += Number(containerItem.height)
        })
        Vue.set(state.page, "height", newTotalHeight)
      }
      // 更新图层标志
      Vue.set(states, "isUpdateLayerDataFlag", true)
    },
    [allTypes.CHANGE_CONTAINER_POSITION](state, data) {
      Vue.set(states, "isUpdateLayerDataFlag", true)
      // 拖拽移动的时候
      if (data.type === "move") {
        const primaryContainer = JSON.parse(JSON.stringify(state.page.children[data.oldIndex]))
        state.page.children.splice(data.oldIndex, 1)
        if (data.newIndex > 0) {
          state.page.children.splice(data.newIndex, 0, primaryContainer)
        } else {
          state.page.children.unshift(primaryContainer)
        }
        return
      }
      const currIndex = state.page.children.findIndex(item => item.container_id === data.id)
      if (currIndex === 0 && data.type === "up") {
        // 第一张不能上移
        return
      }
      if (currIndex === state.page.children.length - 1 && data.type === "down") {
        // 最后一张不能下移
        return
      }
      const primaryContainer = state.page.children[currIndex]
      const brotherContainer =
        data.type === "up" ? state.page.children[currIndex - 1] : state.page.children[currIndex + 1]

      if (data.type === "up") {
        const delVal = state.page.children.splice(currIndex - 1, 2, primaryContainer, brotherContainer)
      } else {
        const delVal = state.page.children.splice(currIndex, 2, brotherContainer, primaryContainer)
      }
      // 更新图层标志
    },
    [allTypes.CHANGE_CONTAINER_SIZE](state, data) {
      if (data.type === "width") {
        getAttrById(state, data, "container").width = data.width
      }
      if (data.type === "height") {
        const newVal = parseFloat(getAttrById(state, data, "container").height) + data.val
        let newTotalHeight = 0
        Vue.set(getAttrById(state, data, "container"), "height", newVal)
        state.page.children.forEach(containerItem => {
          if (
            containerItem.options &&
            containerItem.options.hasOwnProperty("isShow") &&
            !containerItem.options.isShow
          ) {
            return
          }
          if (containerItem.options && containerItem.options.isFixed && containerItem.options.inDocument === "none") {
            return
          }
          if (containerItem.options && containerItem.options.isFixed && containerItem.options.inDocument === "header") {
            // 定位之后的头部，底部 空留出来的高度通过padding来撑
            return
          }
          newTotalHeight += Number(containerItem.height)
        })
        Vue.set(state.page, "height", newTotalHeight)
      }
    },
    [allTypes.CHANGE_CONTAINER_DATA](state, data) {
      let index = state.page.children.findIndex(it => it.container_id === data.container_id)
      Vue.set(state.page.children, index, data)
    },
    [allTypes.COUNT_CONTAINER_HEIGHT](state) {
      let newTotalHeight = 0
      state.page.children.forEach(containerItem => {
        if (containerItem.options && containerItem.options.hasOwnProperty("isShow") && !containerItem.options.isShow) {
          return
        }
        if (containerItem.options && containerItem.options.isFixed && containerItem.options.inDocument === "none") {
          return
        }
        if (containerItem.options && containerItem.options.isFixed && containerItem.options.inDocument === "header") {
          // 定位之后的头部，底部 空留出来的高度通过padding来撑
          return
        }
        newTotalHeight += Number(containerItem.height)
      })
      Vue.set(state.page, "height", newTotalHeight)
    },
    /**
     * 接口事件
     */
    [allTypes.ADD_APPID](state, data) {
      if (!data.id_name) throw new Error("you should give me a id-name key, check your param")
      if (!state.page[data.id_name]) throw new Error("no matching id_name, check your id_name")
      state.page[data.id_name].push(data.id_val)
    },
    [allTypes.UPDATE_APPID](state, data) {
      const rect = getAttrById(state, data)
      if (
        (!data.hasOwnProperty("elementInLayoutId") || data.elementInLayoutId === null) &&
        (!data.hasOwnProperty("elementInSwiperId") || data.elementInSwiperId === null) || 
        (isExist(data.directionIndex) && isExist(data.elementInLayoutId))
      ) {
        Vue.set(rect.options, "appId", data.appId)
      } else {
        const row_id = rect.options.categoryMode === CATEGORY_MODE.SAME ? 0 : rect.options.activeIndex
        const tempRect = [rect.options.rows[row_id]]
        handleFindLayoutComponentOptions(tempRect, data.uid, colsItem => {
          Vue.set(
            colsItem.elementOptions.find(it => it.elementInLayoutId === data.elementInLayoutId),
            "appId",
            data.appId
          )
        })
        Vue.set(getAttrById(state, data, "rect").options.rows, row_id, tempRect[0])
      }
    },
    [allTypes.DEL_APPID](state, data) {
      if (!data.id_name) throw new Error("you should give me a id-name key, check your param")
      if (!state.page[data.id_name]) throw new Error("no matching id_name, check your id_name")
      const appIdArr = state.page[data.id_name]
      const idV = data.id_val
      appIdArr.splice(
        appIdArr.findIndex(item => item.container_id == idV.container_id && item.container_id == idV.rect_id),
        1
      )
    },
    //轮播组件内的布局事件start==-------------------------------------------------------
    [allTypes.CHANGE_ELEMENT_IN_SWIPER_ACTIVE](state, data) {
      const findAttrId = { ...data }
      delete findAttrId.elementInSwiperId
      const attr = getAttribute(state, findAttrId)
      attr.elementOptions.forEach(item => {
        if (item.elementInSwiperId === data.elementInSwiperId) {
          setData(item, true)
        }
        else if (item.isActive === true) {
          // 解决轮播内组件多选，选中效果没有的情况
          let multipleComponent = localStorage.getItem("multipleComponent")
          if (!multipleComponent) {
            setData(item, false)
          }
        }
      })
      function setData(item, val) {
        Vue.set(item, "isActive", val)
      }
    },
    [allTypes.ADD_ELEMENT_IN_SWIPER](state, data) {
      if (data.elementInSwiperId) delete data.elementInSwiperId
      const attr = getAttrById(state, data, "swiperContent")
      //获取payload中的需要添加到轮播页中的组件的options
      const addData = { ...data.elementOptions }
      // 给otpions添加elementinswiperId
      addData.elementInSwiperId =
        attr.elementOptions.length === 0 ? 0 : attr.elementOptions.slice(-1)[0].elementInSwiperId + 1
      getAttrById(state, data, "swiperContent").elementOptions.push(addData)
      // 更新图层标志
      Vue.set(states, "isUpdateLayerDataFlag", true)
    },
    [allTypes.DEL_ELEMENT_IN_SWIPER](state, data) {
      const _elementInSwiperId = data.elementInSwiperId
      delete data.elementInSwiperId

      const attr = getAttrById(state, data, "swiperContent").elementOptions
      const _index = attr.findIndex(item => item.elementInSwiperId === _elementInSwiperId)
      //轮播组件内的组件同时 需要删除该组件的事件（如果有事件的话）
      event.deleteEventByDep({ ...data, elementInSwiperId: _elementInSwiperId }, attr[_index].innerElement)
      delAnimateInRect(state, { ...data, elementInSwiperId: _elementInSwiperId }, attr[_index])
      attr.splice(_index, 1)
      // 更新图层标志
      Vue.set(states, "isUpdateLayerDataFlag", true)
      // 配置了交互的页面 第一个轮播页会出现偶发删除成功 但视图未更新
      const componentBox = document.getElementsByClassName(
        `container_id_${data.container_id}-rect_id_${data.rect_id}-swiperContent_id_${data.swiperContent_id}-elementInSwiperId_${_elementInSwiperId}`
      )[0]
      if (componentBox) {
        componentBox.remove()
      }
    },
    [allTypes.CHANGE_SWIPER_OPTIONS](state, data) {
      const ai = val => Array.isArray(val)
      const attr = getAttrById(state, data, "elementInSwiper")
      if (ai(data.option_val) && ai(data.option_name)) {
        data.option_val.forEach((itemVal, index) => {
          Vue.set(attr, data.option_name[index], itemVal)
        })
      } else {
        changeOption(attr, data)
      }
    },
    [allTypes.CHANGE_SWIPER_CONTENT_OPTIONS](state, data) {
      const attr = getAttrById(state, data, "rect").options.content
      changeOption(attr, data)
    },
    //轮播组件内的布局事件end==-------------------------------------------------------

    //自动布局组件内的布局事件start==-------------------------------------------------------
    [allTypes.CHANGE_ELEMENT_IN_AUTOLAYOUT_ACTIVE](state, data) {
      let tempRectType = data.uid ? "autoLayoutInLayout" : "elementInAutoLayout"
      let tempRect = getAttrById(state, data, "autoLayout").elementOptions // 返回的是 autoLayout容器
      let rootRect
      if (data.uid) {
        // 在自由布局里的自动布局  获取原始数据 浅拷贝
        rootRect = getAttrById(
          state,
          {
            container_id: data.container_id,
            rect_id: data.rect_id,
            uid: data.uid,
            elementInLayoutId: data.elementInLayoutId
          },
          "elementInLayoutOriginalData"
        )
      } else {
        rootRect = getAttrById(
          state,
          {
            container_id: data.container_id,
            rect_id: data.rect_id
          },
          "rect"
        )
      }
      let multipleComponent = localStorage.getItem("multipleComponent")
      if (!multipleComponent) {
        handleClearAllActive(rootRect, data.path, data.elementInAutoLayoutId)
      }
      tempRect.forEach((item, index) => {
        if (item.elementInAutoLayoutId === data.elementInAutoLayoutId) {
          setData(item, true)
        } else if (item[data.option_name] === true && !multipleComponent) {
          setData(item, false)
        }
      })
      function setData(item, val) {
        Vue.set(item, "active", val)
      }
      function handleClearAllActive(tempRect, path, dataElementInAutoLayoutId) {
        let tempPath = path
        if (!path || (Array.isArray(path) && path.length === 0 && typeof dataElementInAutoLayoutId === "undefined")) {
          let elementOptions = tempRect.options ? tempRect.options.elementOptions : tempRect.elementOptions
          Vue.set(tempRect, "active", false)
          if (!elementOptions) {
            return
          }
          for (let i = 0; i < elementOptions.length; i++) {
            if (elementOptions[i].elementInAutoLayoutId !== dataElementInAutoLayoutId) {
              if (elementOptions[i].active) {
                Vue.set(elementOptions[i], "active", false)
              }
              deepHandleClearActive(elementOptions[i])
            }
          }
          return
        }
        tempPath = JSON.parse(JSON.stringify(path))
        let tempElementOptions = tempRect.options ? tempRect.options.elementOptions : tempRect.elementOptions
        Vue.set(tempRect, "active", false)
        if (!tempElementOptions) {
          return
        }
        for (let i = 0; i < tempElementOptions.length; i++) {
          if (tempElementOptions[i].elementInAutoLayoutId === tempPath[0]) {
            tempPath.shift()
            if (tempElementOptions[i].active) Vue.set(tempElementOptions[i], "active", false)
            handleClearAllActive(tempElementOptions[i], tempPath)
          } else {
            if (tempElementOptions[i].active) Vue.set(tempElementOptions[i], "active", false)
            deepHandleClearActive(tempElementOptions[i])
          }
        }
      }
      function deepHandleClearActive(tempRect) {
        let tempElementOptions = tempRect.options ? tempRect.options.elementOptions : tempRect.elementOptions
        Vue.set(tempRect, "active", false)
        if (!tempElementOptions) {
          return
        }
        for (let i = 0; i < tempElementOptions.length; i++) {
          if (tempElementOptions[i].active) {
            Vue.set(tempElementOptions[0], "active", false)
          }
          deepHandleClearActive(tempElementOptions[i])
        }
      }
    },
    [allTypes.CHANGE_ELEMENT_IN_AUTOLAYOUT_UNACTIVE](state, data) {
      let type = data.uid ? "autoLayoutInLayout" : "elementInAutoLayout"
      if (!getAttrById(state, data, "autoLayout")) return
      let tempRect = getAttrById(state, data, "autoLayout").elementOptions // 返回的是 autoLayout容器
      if (!tempRect) return
      tempRect.forEach((item, index) => {
        if (item.active && item.elementInAutoLayoutId !== data.elementInAutoLayoutId) {
          Vue.set(item, "active", false)
        } else {
          deepHandleClearActive(item)
        }
      })
      function deepHandleClearActive(tempRect) {
        let tempElementOptions = tempRect.options ? tempRect.options.elementOptions : tempRect.elementOptions
        if (!tempElementOptions) {
          Vue.set(tempRect, "active", false)
          return
        }
        for (let i = 0; i < tempElementOptions.length; i++) {
          if (tempElementOptions[i].active) Vue.set(tempElementOptions[i], "active", false)
          deepHandleClearActive(tempElementOptions[i])
        }
      }
    },
    [allTypes.ADD_COMPONENT_IN_AUTOLAYOUT](state, data) {
      // 判断是否是多层嵌套
      let type
      let isNestInAutoLayout =
        data.elementInAutoLayoutId === null || typeof data.elementInAutoLayoutId === "undefined" ? false : true
      if ((data.elementInAutoLayoutId !== null || typeof data.elementInAutoLayoutId !== "undefined") && data.uid) {
        type = "autoLayoutInLayout" //在布局里的自由布局
      } else {
        type = !isNestInAutoLayout ? "rect" : "autoLayout"
      }
      let tempRect = getAttrById(state, data, type) // 返回的是 autoLayout容器
      if (tempRect.shape === "cxAutoLayout" && tempRect.elementOptions) {
        // 处理旧数据中有两层elementOptions的情况
        delete tempRect.elementOptions
      }
      const addData = { ...data.elementOptions }
      let maxLayoutId = 0
      const _options = tempRect.options ? tempRect.options : tempRect
      tempRect = _options.elementOptions
      tempRect.forEach(item => {
        maxLayoutId = item.elementInAutoLayoutId > maxLayoutId ? item.elementInAutoLayoutId : maxLayoutId
      })
      // 给options添加elementInAutoLayoutId
      addData.elementInAutoLayoutId = maxLayoutId + 1
      if (addData.innerElement === "cxAutoLayout" && addData?.elementOptions?.length > 0) {
        // 粘贴自动布局时 需要修改布局下的组件的path
        updatePath(addData)
      }
      function updatePath(data) {
        data.elementOptions.forEach(item => {
          let path = Array.isArray(data.path) ? JSON.parse(JSON.stringify(data.path)) : []
          path.push(data.elementInAutoLayoutId)
          item.path = path
          if (item.innerElement === "cxAutoLayout" && item.elementOptions?.length > 0) {
            updatePath(item)
          }
        })
      }
      tempRect.splice(data.insertIndex, 0, addData)
      Vue.set(_options, "elementOptions", tempRect)
      // 更新图层标志
      Vue.set(states, "isUpdateLayerDataFlag", true)
    },
    [allTypes.DEL_ELEMENT_IN_AUTOLAYOUT](state, data) {
      const _elementInAutoLayout = data.elementInAutoLayoutId
      let type = data.uid ? "autoLayoutInLayout" : "elementInAutoLayout"
      const tempRect = getAttrById(state, data, "autoLayout").elementOptions
      const _index = tempRect.findIndex(item => item.elementInAutoLayoutId === _elementInAutoLayout)
      const delRect = tempRect.find(item => item.elementInAutoLayoutId === _elementInAutoLayout)
      window.sessionStorage.setItem("lastDelElementInLayout", JSON.stringify(delRect))
      tempRect.splice(_index, 1)
      // 更新图层标志
      Vue.set(states, "isUpdateLayerDataFlag", true)
    },
    [allTypes.CHANGE_AUTOLAYOUT_OPTIONS](state, data) {
      const ai = val => Array.isArray(val)
      let type = data.uid ? "autoLayoutInLayout" : "elementInAutoLayout"
      let rect = getAttrById(state, data, "autoLayout")
      const tempRect = rect?.elementOptions ? rect.elementOptions : rect
      const _options = rect?.elementOptions
        ? tempRect.find(item => item.elementInAutoLayoutId === data.elementInAutoLayoutId)
        : tempRect
      if (ai(data.option_val) && ai(data.option_name)) {
        data.option_val.forEach((itemVal, index) => {
          Vue.set(_options, data.option_name[index], itemVal)
        })
      } else {
        // Vue.set(_options, data.option_name, data.option_val)
        changeOption(_options, data)
      }
    },
    //自动布局组件内的布局事件end==-------------------------------------------------------
    //==================================================数据列表组件内的布局事件start==================================================
    [allTypes.ADD_COMPONENT_IN_DATAGRID](state, data) {
      let _options = getAttrById(state, data, "dataGrid")
      let cells = JSON.parse(JSON.stringify(_options.cells))
      data.data.elementInDataGridId = uuid.v1()
      for (let i = 0; i < cells.length; i++) {
        cells[i].elementOptions.push(JSON.parse(JSON.stringify(data.data)))
      }
      Vue.set(_options, "cells", cells)
    },
    [allTypes.DEL_ELEMENT_IN_DATAGRID](state, data) {
      let _options = getAttrById(state, data, "dataGrid")
      let cells = _options.cells
      for (let i = 0; i < cells.length; i++) {
        const cell = cells[i]
        for (let j = 0; j < cell.elementOptions.length; j++) {
          const element = cell.elementOptions[j]
          if (element.elementInDataGridId === data.elementInDataGridId) {
            delAnimateInRect(state, {
              container_id: data.container_id,
              rect_id: data.rect_id,
              path:data.path,
              elementInAutoLayoutId: data.elementInAutoLayoutId,
              cellId: cells[i].cellId,
              elementInDataGridId:data.elementInDataGridId,
              elementInLayoutId: data.elementInLayoutId,
            }, cell.elementOptions[j])
            let tempElementOptions = JSON.parse(JSON.stringify(cell.elementOptions))
            tempElementOptions.splice(j, 1)
            Vue.set(cells[i], "elementOptions", tempElementOptions)
            continue
          }
        }
      }
    },
    [allTypes.CHANGE_DATAGRID_OPTIONS](state, data) {
      let rect = getAttrById(state, data, data.type)
      if (data.type === "dataGridCell") {
        rect = rect.options
      }
      changeOption(rect, data)
    },
    [allTypes.CHANGE_DATAGRID_LAYOUT] (state, data) {
      const rect = getAttrById(state, data, "dataGrid")
      Vue.set(rect, "row", data.row)
      Vue.set(rect, "col", data.col)
      // 需要根据行列的值来设置单元格的宽度百分比
      const width = Math.floor(100 /data.col)
      Vue.set(rect.cells[0].options, "width", width)

      const cell_count = data.row * data.col
      let cells = []
      for (let i = 0; i < cell_count; i++) {
        let cell_temp = JSON.parse(JSON.stringify(rect.cells[0]))
        if (i > 0) {
          cell_temp.cellId = uuid.v1()
        }
        cells.push(cell_temp)
      }
      // 基于cells中第一个对象，克隆cell_count - 1次，并更新cells属性
      Vue.set(rect, "cells", cells)
    },
    //==================================================数据列表组件内的布局事件end==================================================
    //页面布局组件内的布局事件start==-------------------------------------------------------
    [allTypes.ADD_ELEMENT_IN_PAGE_LAYOUT](state, data) {
      const tempRect = getAttrById(state, data)
      const _options = tempRect.options
      let childrenRect = _options.childrenRect
      childrenRect.splice(data.insertIndex, 0, data.childrenRect_id)
      Vue.set(_options, "childrenRect", childrenRect)
    },
    [allTypes.DEL_ELEMENT_IN_PAGE_LAYOUT](state, data) {
      const tempRect = getAttrById(state, data, type)
      const _options = tempRect.options
      let childrenRect = _options.childrenRect
      childrenRect.splice(data.deleIndex, 1)
      Vue.set(_options, "childrenRect", childrenRect)
    },
    //页面布局组件内的布局事件end==-------------------------------------------------------

    //初始化webjson
    [allTypes.INIT_STAGE_DATA](state, data) {
      if (!data.page || !data.page.children) {
        return
      }
      if (data.page.stageType !== "layOut") {
        data.page.height =
          data.page.children.length > 1
            ? data.page.children.reduce((curr, next) => {
                return typeof curr === "number" ? curr + next.height : curr.height + next.height
              })
            : data.page.children[0].height
      }
      // 需要处理没有themeColorList字段的情况，构造一个默认值
      if (data.page.themeColor && !data.page.themeColorList) {
        data.page.themeColorList = [
          {
            id: 0,
            color: data.page.themeColor,
            name: "主题色1",
            tags: ""
          }
        ]
      }
      delete data.page.zoom
      Vue.set(state, "page", data.page)
      Vue.set(state, "type", data.type ? data.type : "normal") // 新增page类型
      Vue.set(state, "treeData", data.treeData)
      Vue.set(state, "version", data.version)
      Vue.set(states, "isUpdateLayerDataFlag", true)
      // 该标识用于判断保存时的store数据是否来源于接口而不是本地的初始化数据
      Vue.set(state, "isInitedFromInterface", true)
    },
    // 修改页面布局
    [allTypes.CHANGE_PAGE_LAYOUT](state, data) {
      Vue.set(state.page, "pageLayoutList", data.pageLayoutList)
    },
    [allTypes.CHANGE_PAGE_LAYOUT_ROW](state, data) {
      console.log("state :>>", state, data)

      let newHeight = 0
      data.pageLayout.forEach(item => {
        newHeight += item.options.height
      })
      let tempPageLayout = getAttrById(state, data, "pageLayout")
      Vue.set(tempPageLayout.layout, "rows", data.pageLayout)
      Vue.set(tempPageLayout.options, "height", newHeight)
    },
    [allTypes.INSERT_PAGE_LAYOUT](state, data) {
      let tempPageLayout = state.page.pageLayoutList
      tempPageLayout.splice(data.index, 0, data.pagelayout_data)
      Vue.set(state.page, "pageLayoutList", tempPageLayout)
    },
    [allTypes.CHANGE_PAGE_LAYOUT_TABS_LENGTH](state, payload) {
      const tabOptions = getAttrById(state, payload, "rect").options
      const currentTabsLength = tabOptions?.tabsList?.length
      if (!currentTabsLength) return
      if (payload.tabLength > currentTabsLength) {
        const addLength = payload.tabLength - currentTabsLength
        for (let i = 1; i <= addLength; i++) {
          tabOptions?.tabsList.push({
            name: "选项" + (currentTabsLength + i),
            id: uuid.v1()
          })
        }
      } else if (payload.tabLength < currentTabsLength) {
        const deleteLength = currentTabsLength - payload.tabLength
        for (let i = 1; i <= deleteLength; i++) {
          tabOptions?.tabsList.splice(payload.curIndex ? payload.curIndex : tabOptions.tabsList.length - 1, 1)
        }
      }
    },
    [allTypes.CHANGE_VERSION](state) {
      const newvVersion = Number(state.version) + 1
      Vue.set(state, "version", newvVersion)
    },
    [allTypes.CLEAR_ALL_RECT](state) {
      event.clearAllEvents()
      state.page.children.forEach(stage => {
        stage.children = []
        Vue.delete(stage.options, "headComponentMap") //删除头部组件映射关系
      })
      //清空布局里头部通栏保存的组件
      const headLayout =
        state.page.pageLayoutList && state.page.pageLayoutList.find(layout => layout.options.inDocument === "header")
      if (headLayout && headLayout.options.headComponentMap) {
        for (let k in headLayout.options.headComponentMap) {
          headLayout.options.headComponentMap[k] = ""
        }
      }
      // 清空布局里面的组件
      state.page.pageLayoutList?.forEach(item => {
        item.layout.rows.forEach(subItem => {
          subItem.rectIds = []
          clearLayoutRectIds(subItem.layout)
        })
      })
      function clearLayoutRectIds(objArr) {
        objArr.rows.forEach(item => {
          item.rectIds = []
          clearLayoutRectIds(item.layout)
        })
        objArr.cols.forEach(item => {
          item.rectIds = []
          clearLayoutRectIds(item.layout)
        })
      }
    },
    [allTypes.CHANGE_PAGE_TYPE](state, data) {
      Vue.set(state, "type", data)
    },
    [allTypes.CHANGE_ATTRIBUTE](state, data) {
      const { option_name, option_val } = data
      if (option_name.includes(".")) {
        //深度属性
        let handle = state.page
        const link = option_name.split(".")
        link.slice(0, -1).forEach((k, index) => {
          if (Object.prototype.toString.call(this, handle[k]) !== "[object Object]") {
            throw new Error(`value: '${k}' is not a object,please check params`)
          } else {
            handle = handle[k]
          }
        })
        console.log(handle)
        Vue.set(handle, link[link.length - 1], option_val)
      } else {
        //浅层属性
        Vue.set(state.page, option_name, option_val)
        // pc端 修改版心
        if (option_name === "pageWidth" && state.page.isPcFixedTypeArea) {
          state.page.children.forEach(item => {
            if (state.page.stageType !== "position") {
              Vue.set(item, "width", option_val)
            }
          })
        }
      }
    },
    [allTypes.CHANGE_STAGE_LAYOUT_OPTION](state, data) {
      if (data.uid) {
        //有uid 是改layout布局配置项对象
        const rows = state.page.layoutOption.rows
        handleFindLayoutStageOptionsByUid(rows, data.uid, opt => {
          if (data.type === "del") {
            Vue.delete(opt, data.key)
          } else {
            Vue.set(opt, data.key, data.value)
          }
        })
      } else {
        //没有uid 改layoutoption对象内部的某个属性
        if (state.page.hasOwnProperty("layoutOption")) {
          Vue.set(state.page.layoutOption, data.key, data.value)
        }
      }
    },
    [allTypes.CHANGE_CONTAINER_ATTRIBUTE](state, data) {
      changeOption(getAttrById(state, data, "container"), { option_name: data.key, option_val: data.data })
      if ("widthheight".includes(data.key)) {
        //如果stage改变了宽高 container的宽高也要变
        let maxW = 0,
          maxH = 0
        state.page.children.forEach(container => {
          maxH += container.height
          maxW = container.width > maxW ? container.width : maxW
        })
        maxH && Vue.set(state.page, "pageWidth", maxW)
        maxH && Vue.set(state.page, "height", maxH)
      }
    },
    [allTypes.CHANGE_LAYOUT_TABS_LENGTH](state, payload) {
      let rect = getAttrById(state, payload, "rect").options
      if (payload.elementInAutoLayoutId !== undefined) {
        rect = getAttrById(state, payload, "elementInAutoLayout")
      }
      rect.titleOptions[payload.directionIndex].elementOptions.find(
        it => it.elementInLayoutId === payload.elementInLayoutId || it.innerElement === "cxTabs"
      ).options.maxLength = payload.maxLength
      const currentRowsLength = rect.rows.length
      const currentTabsLength = rect.titleOptions[payload.directionIndex].elementOptions.find(
        it => it.elementInLayoutId === payload.elementInLayoutId || it.innerElement === "cxTabs"
      ).options?.tabsList?.length
      if (!currentTabsLength) return
      if (payload.maxLength > currentRowsLength) {
        const addLength = payload.maxLength - currentRowsLength
        for (let i = 1; i <= addLength; i++) {
          const temp = {
            height: "100%",
            alginH: "center",
            cols: [
              {
                uid: uuid.v1(),
                alignSelf: "stretch",
                md: 12,
                appMd: 12,
                width: "100%",
                height: "100%",
                offsetMd: 0,
                component: null,
                elementOptions: [],
                componentBoxOptions: {
                  paddingTop: 0,
                  paddingBottom: 0,
                  paddingLeft: 0,
                  paddingRight: 0,
                  borderStyle: "solid", // solid, dashed, dotted
                  borderColor: "#FFFFFF",
                  borderWidth: 0,
                  clipSize: "cover",
                  repeatType: "no-repeat",
                  alignType: "center center",
                  imgSrc: "",
                  opacity: 100
                }
              }
            ]
          }
          if (payload?.twoTabsLayoutPlugin) {
            let tabsList = rect.titleOptions[payload.directionIndex].elementOptions.find(
              it => it.elementInLayoutId === payload.elementInLayoutId || it.innerElement === "cxTabs"
            ).options.tabsList
            if(rect.categoryMode !== CATEGORY_MODE.SAME) {
              rect.rows.unshift(temp)
            }
            if (tabsList[0].name != "我常用的") {
              tabsList.unshift({
                name: "我常用的",
                id: uuid.v1()
              })
            }
          } else {
            if(rect.categoryMode !== CATEGORY_MODE.SAME) {
              rect.rows.push(temp)
            }
            rect.titleOptions[payload.directionIndex].elementOptions
              .find(it => it.elementInLayoutId === payload.elementInLayoutId || it.innerElement === "cxTabs")
              .options.tabsList.push({
                name: "Tab" + (currentTabsLength + i),
                id: uuid.v1()
              })
          }
        }
      } else if (payload.maxLength < currentRowsLength) {
        const deleteLength = currentRowsLength - payload.maxLength
        for (let i = 1; i <= deleteLength; i++) {
          rect.rows.splice(payload.curIndex === undefined ? rect.rows.length - 1 : payload.curIndex, 1)
          rect.titleOptions[payload.directionIndex].elementOptions
            .find(it => it.elementInLayoutId === payload.elementInLayoutId || it.innerElement === "cxTabs")
            .options.tabsList.splice(
              payload.curIndex === undefined
                ? rect.titleOptions[payload.directionIndex].elementOptions.find(
                    it => it.elementInLayoutId === payload.elementInLayoutId || it.innerElement === "cxTabs"
                  ).options.tabsList.length - 1
                : payload.curIndex,
              1
            )
        }
      }
      if (!payload.isAsyncData) {
        // 通过数据同步不需要改变当前选中的tab
        Vue.set(
          rect.titleOptions[payload.directionIndex].elementOptions.find(
            it => it.elementInLayoutId === payload.elementInLayoutId || it.innerElement === "cxTabs"
          ).options,
          "activeIndex",
          rect.rows.length - 1
        )
        Vue.set(rect, "activeIndex", rect.rows.length - 1)
      }
    },
    [allTypes.INIT_LAYOUT_OTHERS](state, payload) {
      getAttrById(state, payload, "rect").options.titleOptions.forEach((titleItem, i) => {
        titleItem.elementOptions.forEach((elementItem, j) => {
          switch (elementItem.type) {
            case "classification":
              // todo
              getAttrById(state, payload, "rect").options.titleOptions[i].elementOptions[j].options.tabsList =
                payload.data.tabs
              break
            case "title":
              getAttrById(state, payload, "rect").options.titleOptions[i].elementOptions[j].options.content =
                payload.data.title.name
              break
            case "subTitle":
              getAttrById(state, payload, "rect").options.titleOptions[i].elementOptions[j].options.content =
                payload.data.subTitle.name
              break
            case "more":
              getAttrById(state, payload, "rect").options.titleOptions[i].elementOptions[j].options.content =
                payload.data.more.name
              break
          }
        })
      })
    },
    //在组件发生增删后更新左侧图层布局组件的树形结构
    [allTypes.UPDATE_TREE_DATA](state, data) {
      let rectOptions = getAttribute(state, data).options
      const row_id = rectOptions.categoryMode === CATEGORY_MODE.SAME ? 0 : rectOptions.activeIndex
      let rowData = { label: "row", id: 0, children: [] }
      const allTreeRects = getTreeAttrById(state, data, "container").children
      let result = handleFindLayoutComponentsLevel(rectOptions.rows[row_id].cols, rowData)
      allTreeRects[allTreeRects.findIndex(it => it.id === data.rect_id)].children[0].children.splice(0, 1, result)
    },
    // 改变布局组件中块的尺寸
    [allTypes.CHANGE_LAYOUT_BLOCK_SIZE](state, data) {
      const ids = {
        container_id: data.data.list[0].id,
        rect_id: data.data.list[1].id
      }
      let rectOptions = getAttribute(state, ids).options
      const row_id = rectOptions.categoryMode === CATEGORY_MODE.SAME ? 0 : rectOptions.activeIndex
      let tempRect = [JSON.parse(JSON.stringify(rectOptions.rows[row_id]))]
      let col_uid = null
      if (data.data.list.length > 5) {
        if (data.type == "col") {
          col_uid = data.data.list[data.data.list.length - 3].uid
        } else {
          col_uid = data.data.list[data.data.list.length - 2].uid
        }
        handleFindLayoutComponentOptions(tempRect, col_uid, colsItem => {
          if (data.type == "col") {
            colsItem.rows[data.data.list[data.data.list.length - 2].id].cols.map((item, index) => {
              item.width = data.list[index]
            })
          } else {
            colsItem.rows.map((item, index) => {
              item.height = data.list[index]
            })
          }
        })
      } else {
        tempRect[0].cols.map((item, index) => {
          item.width = data.list[index]
        })
      }
      Vue.set(rectOptions.rows, row_id, tempRect[0])
    },
    // 改变列表页中的配置项
    [allTypes.CHANGE_LIST_PAGE_SETTING](state, data) {
      Vue.set(state.page.listPageSetting, data.key, data.data)
    },
    // 改变详情页页中的配置项
    [allTypes.CHANGE_DETAIL_PAGE_SETTING](state, data) {
      Vue.set(state.page.detailPageSetting, data.key, data.data)
    },
    // 改变子页面映射关系
    [allTypes.CHANGE_SUB_PAGE_MAPPING](state, data) {
      Vue.set(state.page, "subPages", data)
    },
    // 改变翻页模版标识
    [allTypes.CHANGE_PHONE_FULL_SCREEN](state, data) {
      Vue.set(state.page, "isPhoneFullScreen", data)
    },
    // 改变当前页面的类型 是否为布局模式
    [allTypes.CHANGE_PAGE_LAYOUT_TYPE](state, data) {
      Vue.set(state.page, "pageLayoutType", data)
    },
    // 修改是否是独立的移动端
    [allTypes.CHANGE_ONLY_H5_TEMPLATE](state, data) {
      Vue.set(state.page, "isOnlyH5Template", data)
    },
    // 修改飘窗状态
    [allTypes.CHANGE_BAYWINDOW_STATUS](state) {
      if (!state.page.global) {
        Vue.set(state.page, "global", {})
      }
      Vue.set(state.page.global, "bayWindowOpen", !state.page.global.bayWindowOpen)
    },
    //将所有分类对应的row的组件替换成第一个分类下的rows的组件
    [allTypes.CHANGE_LAYOUT_BLOCK_BY_TABS](state, data) {
      const len = getAttribute(state, data).options.rows.length
      let newRows = []
      for (let i = 0; i < len; i++) {
        let tempRow = JSON.parse(JSON.stringify(getAttribute(state, data).options.rows[0]))
        tempRow.cols[0].uid = uuid.v1()
        newRows.push(tempRow)
      }
      Vue.set(getAttribute(state, data).options, "rows", newRows)
    }
  }
}
